import React, { useState, useRef, useEffect, useCallback, useContext, useMemo } from "react";
import { Table, Form, Button, Modal, Alert } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import { MdFileUpload } from "react-icons/md";
import { Tooltip } from '@mui/material';
import "react-toastify/dist/ReactToastify.css";
import { statusColor } from "../../utils/statusColor";
import {
  FaChevronDown,
  FaEye,
  FaDownload,
  FaTrash,
  FaUpload,
  FaEdit, FaReceipt,
  FaSave,
  FaTimes,
  FaAd,
  FaPlus,
} from "react-icons/fa";
import Papa from "papaparse";
import { useNavigate, useLocation } from "react-router-dom";
import { saveAs } from "file-saver";
import pdfimage from "../images/pdf_downlaod.png";
import { BASE_URL } from "../../api/api";
import { AuthContext } from "../../context/AuthContext";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Chip from "@mui/material/Chip";


const ReviewBatchPage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { selectedBatchData, vendorId, isExcelUpload } = state || {};
  const { user } = useContext(AuthContext);
  const fileInputRef = useRef();
  const modalFileInputRef = useRef();
  const [rowDeleted, setRowDeleted] = useState(false);

  const [invoices, setInvoices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [modalActionType, setModalActionType] = useState("");
  const [isGSTApplied, setIsGSTApplied] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [fileType, setFileType] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [caseCount, setCaseCount] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [invoiceAmount, setInvoiceAmount] = useState("");
  const [amountError, setAmountError] = useState("");
  const [hoveredRow, setHoveredRow] = useState(null);
  const [openRemarkModal, setOpenRemarkModal] = useState(false);
  const [nextAction, setNextAction] = useState(null)
  const [selectedInvoiceIndex, setSelectedInvoiceIndex] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [remarkFile, setRemarkFile] = useState(null);
  const [previousInvoices, setPreviousInvoices] = useState([]);
  const [showRemarkModal, setShowRemarkModal] = useState(false);
  const [batchRemark, setBatchRemark] = useState("");
  const [fieldErrors, setFieldErrors] = useState({
    invoiceNo: false,
    invoiceDate: false,
    invoiceAmount: false,
    caseCount: false,
    uploadedFile: false,
    remarks: {},
  });
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingInvoice, setEditingInvoice] = useState(null);
  const [editValues, setEditValues] = useState({
    serviceCharges: "",
    repairCharges: "",
    remarks: "",
    file: null, billingType: "billing",
    fileName: "",
  });
  const [modalClaimData, setModalClaimData] = useState(null);
  const [activePreviewTab, setActivePreviewTab] = useState("challan");

  const [originalCaseCount, setOriginalCaseCount] = useState("");
  const [originalInvoiceAmount, setOriginalInvoiceAmount] = useState("");
  const [rightSideCaseCount, setRightSideCaseCount] = useState("");
  const [rightSideInvoiceAmount, setRightSideInvoiceAmount] = useState("");
  const [aaNumber, setAaNumber] = useState("");
  const [showaaNumber, setShowAaNumber] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filterType, setFilterType] = useState("closure");
  const [showFilter, setShowFilter] = useState(false);
  const [deletedAANumbers, setDeletedAANumbers] = useState([]);
  const numberToWords = (num) => {
    const a = ['', 'One ', 'Two ', 'Three ', 'Four ', 'Five ', 'Six ', 'Seven ', 'Eight ', 'Nine ', 'Ten ', 'Eleven ', 'Twelve ', 'Thirteen ', 'Fourteen ', 'Fifteen ', 'Sixteen ', 'Seventeen ', 'Eighteen ', 'Nineteen '];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    if ((num = num.toString()).length > 9) return 'overflow';
    let n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return '';
    let str = '';
    str += parseInt(n[1]) !== 0 ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'Crore ' : '';
    str += parseInt(n[2]) !== 0 ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'Lakh ' : '';
    str += parseInt(n[3]) !== 0 ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'Thousand ' : '';
    str += parseInt(n[4]) !== 0 ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'Hundred ' : '';
    str += parseInt(n[5]) !== 0 ? ((str !== '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) : '';
    return str.trim() ? str.trim() + ' Rupees Only' : 'Zero Rupees Only';
  };

  const getHsnSac = (materialName) => {
    const name = (materialName || "").toUpperCase();
    if (name.includes("DISPLAY")) return "85177990";
    if (name.includes("FRAME")) return "85177990";
    if (name.includes("BATTERY")) return "39269099";
    if (name.includes("COVER")) return "39269099";
    if (name.includes("STICKER")) return "48239090";
    if (name.includes("SERVICE") || name.includes("LOGISTIC")) return "998716";
    return "85177990"; // default fallback HSN
  };

  const getVendorDetails = (vendorName, state) => {
    const defaults = {
      name: vendorName || "Chitransh Enterprises",
      address: "1685, Shyam Nath Tiwari Ki Gali, Choura Rasta, Jaipur",
      phone: "9460871655",
      gstin: "08AUMPB7316G1ZO",
      state: "08-Rajasthan"
    };

    const nameUpper = (vendorName || "").toUpperCase();
    if (nameUpper.includes("CHITRANSH")) {
      return defaults;
    } else if (nameUpper.includes("NPD")) {
      return {
        name: "NPD Enterprises - Meerut",
        address: "Meerut Road, Near Bypass, Meerut",
        phone: "9837011777",
        gstin: "09AUMPB7316G1ZO",
        state: "09-Uttar Pradesh"
      };
    }

    const stateStr = state || "Rajasthan";
    const stateCode = stateStr.toUpperCase().includes("UTTAR PRADESH") ? "09" : "08";
    return {
      name: vendorName || "Chitransh Enterprises",
      address: stateStr + ", India",
      phone: "9460871655",
      gstin: `${stateCode}AUMPB7316G1ZO`,
      state: `${stateCode}-${stateStr}`
    };
  };

  const getDisplayItems = () => {
    const inputRepair = parseFloat(editValues.repairCharges) || 0;
    const inputService = parseFloat(editValues.serviceCharges) || 0;

    const formattedRepairParts = [];
    if (inputRepair > 0) {
      formattedRepairParts.push({
        name: "Repair Charges",
        hsn: "",
        quantity: 1,
        unit: "Pcs",
        price: inputRepair,
        gstRate: 18,
        gstAmount: isGSTApplied ? inputRepair * 0.18 : 0,
        amount: isGSTApplied ? inputRepair * 1.18 : inputRepair
      });
    }

    const formattedServiceParts = [];
    if (inputService > 0) {
      formattedServiceParts.push({
        name: "Logistic Charges",
        hsn: "",
        quantity: 1,
        unit: "Pcs",
        price: inputService,
        gstRate: 18,
        gstAmount: isGSTApplied ? inputService * 0.18 : 0,
        amount: isGSTApplied ? inputService * 1.18 : inputService
      });
    }

    return {
      repair: formattedRepairParts,
      service: formattedServiceParts
    };
  };

  const downloadChallanPDF = (invoice, itemsData, shouldSave = true, externalDoc = null) => {
    console.log('test item ', itemsData);
    const doc = externalDoc || new jsPDF();
    const vendor = getVendorDetails(selectedBatchData?.vendorName || invoice?.sellingPartner, modalClaimData?.ascState);
    const customerName = invoice?.customerName || "Customer";
    const aaNumber = invoice?.aA_Number || "";
    const imei = invoice?.imeiNumber || "";
    const device = `${invoice?.brand || ""} ${invoice?.makeModel || ""}`;
    const invoiceNo = selectedBatchData?.invoiceNo || `AA/CE/${invoice?.id || 1}`;
    const invoiceDate = selectedBatchData?.invoiceDate
      ? new Date(selectedBatchData.invoiceDate).toLocaleDateString('en-GB').replace(/\//g, '-')
      : new Date().toLocaleDateString('en-GB').replace(/\//g, '-');

    const customerAddress = modalClaimData?.address || "Address Not Found";
    const customerPincode = modalClaimData?.pincode || "";

    // 1. Header
    doc.setFont("Helvetica", "bold");
    doc.setFontSize(14);
    doc.text(vendor.name, 15, 20);

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(80, 80, 80);
    doc.text(vendor.address, 15, 25);
    doc.text(`Phone no. : ${vendor.phone}`, 15, 30);
    doc.text(`GSTIN : ${vendor.gstin}`, 15, 35);
    doc.text(`State: ${vendor.state}`, 15, 40);

    // Horizontal Line
    doc.setDrawColor(220, 220, 220);
    doc.setLineWidth(0.5);
    doc.line(15, 45, 195, 45);

    // 2. Title
    doc.setFont("Helvetica", "bold");
    doc.setFontSize(14);
    doc.setTextColor(114, 28, 36); // Maroon color
    doc.text("Challan", 105, 53, { align: "center" });

    // 3. Columns: To & Details
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(9);
    doc.setFont("Helvetica", "bold");
    doc.text("To", 15, 62);
    doc.text("Across Assist Pvt Ltd c/o " + customerName + " (" + aaNumber + ")", 15, 67);

    doc.setFont("Helvetica", "normal");
    const addrLines = doc.splitTextToSize(customerAddress + (customerPincode ? `\nPin Code - ${customerPincode}` : "") + "\nGST IN: 06AAHCB4822B1Z6", 90);
    doc.text(addrLines, 15, 72);

    // Right Column
    doc.setFont("Helvetica", "bold");
    doc.text("Challan Details", 130, 62);
    doc.setFont("Helvetica", "normal");
    doc.text(`No. : ${invoiceNo}`, 130, 67);
    doc.text(`Date : ${invoiceDate}`, 130, 72);

    // 4. Table Rows
    const tableBody = itemsData.map((item, idx) => [
      idx + 1,
      item.name,
      item.quantity,
      item.unit,
      "Rs. " + parseFloat(item.price).toFixed(2),
      "Rs. " + parseFloat(item.price * item.quantity).toFixed(2)
    ]);

    const totalQty = itemsData.reduce((sum, item) => sum + item.quantity, 0);
    const subTotal = itemsData.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    const totalWithGST = subTotal; // Challan does not have GST

    // Add total row
    tableBody.push([
      { content: "Total", colSpan: 2, styles: { fontStyle: "bold", halign: "left" } },
      { content: totalQty.toString(), styles: { fontStyle: "bold", halign: "center" } },
      "",
      "",
      { content: "Rs. " + totalWithGST.toFixed(2), styles: { fontStyle: "bold", halign: "right" } }
    ]);

    // Draw Table
    autoTable(doc, {
      startY: 95,
      head: [["#", "Item name", "Quantity", "Unit", "Price/ Unit", "Amount"]],
      body: tableBody,
      theme: "grid",
      headStyles: {
        fillColor: [92, 37, 24],
        textColor: [255, 255, 255],
        fontStyle: "bold",
        fontSize: 8,
        halign: "center"
      },
      columnStyles: {
        0: { halign: "center", cellWidth: 10 },
        1: { halign: "left", cellWidth: 80 },
        2: { halign: "center", cellWidth: 20 },
        3: { halign: "center", cellWidth: 20 },
        4: { halign: "right", cellWidth: 25 },
        5: { halign: "right", cellWidth: 25 }
      },
      styles: {
        fontSize: 8,
        cellPadding: 3
      },
      didParseCell: function (data) {
        if (data.row.index === tableBody.length - 1) {
          data.cell.styles.fillColor = [245, 245, 245];
        }
      }
    });

    const finalY = doc.lastAutoTable.finalY + 10;

    // 5. Bottom Sections: Left (Details, Words, Terms) and Right (Totals box)
    let currY = finalY;
    doc.setFont("Helvetica", "bold");
    doc.text("Description", 15, currY);
    doc.setFont("Helvetica", "normal");
    currY += 5;
    doc.text(`Repair support for ${device}`, 15, currY);
    doc.text(`IMEI: ${imei}`, 15, currY + 4);

    doc.setFont("Helvetica", "bold");
    doc.text("Amount In Words", 15, currY + 12);
    doc.setFont("Helvetica", "normal");
    const roundedTotal = Math.round(totalWithGST);
    doc.text(numberToWords(roundedTotal), 15, currY + 17);

    doc.setFont("Helvetica", "bold");
    doc.text("Terms and Conditions", 15, currY + 25);
    doc.setFont("Helvetica", "normal");
    doc.text("1. E.&O.E.", 15, currY + 30);

    // Right Section: Summary Box
    const boxX = 125;
    const boxWidth = 70;
    let boxY = finalY;

    // Subtotal Row
    doc.rect(boxX, boxY, boxWidth, 7);
    doc.setFont("Helvetica", "normal");
    doc.text("Sub Total", boxX + 5, boxY + 5);
    doc.text("Rs. " + subTotal.toFixed(2), boxX + boxWidth - 5, boxY + 5, { align: "right" });
    boxY += 7;

    // Roundoff Row
    const roundOffVal = roundedTotal - totalWithGST;
    doc.rect(boxX, boxY, boxWidth, 7);
    doc.text("Round off", boxX + 5, boxY + 5);
    doc.text((roundOffVal >= 0 ? "+ " : "- ") + "Rs. " + Math.abs(roundOffVal).toFixed(2), boxX + boxWidth - 5, boxY + 5, { align: "right" });
    boxY += 7;

    // Total Row (Maroon Banner)
    doc.setFillColor(92, 37, 24);
    doc.rect(boxX, boxY, boxWidth, 8, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFont("Helvetica", "bold");
    doc.text("Total", boxX + 5, boxY + 5.5);
    doc.text("Rs. " + roundedTotal.toFixed(2), boxX + boxWidth - 5, boxY + 5.5, { align: "right" });

    // Reset Text Color
    doc.setTextColor(0, 0, 0);

    // Signature Area
    let sigY = boxY + 18;
    doc.setFont("Helvetica", "normal");
    doc.setFontSize(8);
    doc.text(`For : ${vendor.name}`, boxX + 5, sigY);

    // Draw Stamp
    const stampX = boxX + boxWidth / 2 - 10;
    const stampY = sigY + 12;
    doc.setDrawColor(0, 51, 153);
    doc.setLineWidth(0.8);
    doc.circle(stampX, stampY, 12);

    doc.setTextColor(0, 51, 153);
    doc.setFontSize(5);
    doc.setFont("Helvetica", "bold");
    doc.text("CHITRANSH", stampX, stampY - 3, { align: "center" });

    doc.setFontSize(7);
    doc.setFont("Helvetica", "oblique");
    doc.text("Honey", stampX, stampY + 1, { align: "center" });

    doc.setFontSize(5);
    doc.setFont("Helvetica", "bold");
    doc.text("ENTERPRISES", stampX, stampY + 5, { align: "center" });

    doc.setTextColor(0, 0, 0);
    doc.setFontSize(8);
    doc.setFont("Helvetica", "bold");
    doc.text("Authorized Signatory", boxX + 5, sigY + 28);

    if (shouldSave) {
      doc.save(`Challan_${aaNumber}.pdf`);
    }
    return doc;
  };

  const downloadInvoicePDF = (invoice, itemsData, shouldSave = true, externalDoc = null) => {
    const doc = externalDoc || new jsPDF();
    const vendor = getVendorDetails(selectedBatchData?.vendorName || invoice?.sellingPartner, modalClaimData?.ascState);
    const customerName = invoice?.customerName || "Customer";
    const aaNumber = invoice?.aA_Number || "";
    const imei = invoice?.imeiNumber || "";
    const device = `${invoice?.brand || ""} ${invoice?.makeModel || ""}`;
    const invoiceNo = selectedBatchData?.invoiceNo || `AA/CE/${invoice?.id || 1}`;
    const invoiceDate = selectedBatchData?.invoiceDate
      ? new Date(selectedBatchData.invoiceDate).toLocaleDateString('en-GB').replace(/\//g, '-')
      : new Date().toLocaleDateString('en-GB').replace(/\//g, '-');

    const customerAddress = modalClaimData?.address || "Address Not Found";
    const customerPincode = modalClaimData?.pincode || "";

    // 1. Header
    doc.setFont("Helvetica", "bold");
    doc.setFontSize(14);
    doc.text(vendor.name, 15, 20);

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(80, 80, 80);
    doc.text(vendor.address, 15, 25);
    doc.text(`Phone no. : ${vendor.phone}`, 15, 30);
    doc.text(`GSTIN : ${vendor.gstin}`, 15, 35);
    doc.text(`State: ${vendor.state}`, 15, 40);

    // Horizontal Line
    doc.setDrawColor(220, 220, 220);
    doc.setLineWidth(0.5);
    doc.line(15, 45, 195, 45);

    // 2. Title
    doc.setFont("Helvetica", "bold");
    doc.setFontSize(14);
    doc.setTextColor(114, 28, 36); // Maroon color
    doc.text("Tax Invoice", 105, 53, { align: "center" });

    // 3. Columns: To & Details
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(9);
    doc.setFont("Helvetica", "bold");
    doc.text("Bill To", 15, 62);
    doc.text("Across Assist Pvt Ltd c/o " + customerName + " (" + aaNumber + ")", 15, 67);

    doc.setFont("Helvetica", "normal");
    const addrLines = doc.splitTextToSize(customerAddress + (customerPincode ? `\nPin Code - ${customerPincode}` : "") + "\nGST IN: 06AAHCB4822B1Z6", 90);
    doc.text(addrLines, 15, 72);

    // Right Column
    doc.setFont("Helvetica", "bold");
    doc.text("Invoice Details", 130, 62);
    doc.setFont("Helvetica", "normal");
    doc.text(`No. : ${invoiceNo}`, 130, 67);
    doc.text(`Date : ${invoiceDate}`, 130, 72);

    // 4. Table Rows
    const tableBody = itemsData.map((item, idx) => [
      idx + 1,
      item.name,
      item.quantity,
      item.unit,
      "Rs. " + parseFloat(item.price).toFixed(2),
      `Rs. ${parseFloat(item.gstAmount).toFixed(2)} (${item.gstRate}%)`,
      "Rs. " + parseFloat(item.amount).toFixed(2)
    ]);

    const totalQty = itemsData.reduce((sum, item) => sum + item.quantity, 0);
    const subTotal = itemsData.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    const totalGst = itemsData.reduce((sum, item) => sum + item.gstAmount, 0);
    const totalWithGST = itemsData.reduce((sum, item) => sum + item.amount, 0);

    // Add total row
    tableBody.push([
      { content: "Total", colSpan: 2, styles: { fontStyle: "bold", halign: "left" } },
      { content: totalQty.toString(), styles: { fontStyle: "bold", halign: "center" } },
      "",
      "",
      "",
      { content: "Rs. " + totalWithGST.toFixed(2), styles: { fontStyle: "bold", halign: "right" } }
    ]);

    // Draw Table
    autoTable(doc, {
      startY: 95,
      head: [["#", "Item name", "Quantity", "Unit", "Price/ Unit", "GST", "Amount"]],
      body: tableBody,
      theme: "grid",
      headStyles: {
        fillColor: [92, 37, 24],
        textColor: [255, 255, 255],
        fontStyle: "bold",
        fontSize: 8,
        halign: "center"
      },
      columnStyles: {
        0: { halign: "center", cellWidth: 10 },
        1: { halign: "left", cellWidth: 70 },
        2: { halign: "center", cellWidth: 20 },
        3: { halign: "center", cellWidth: 15 },
        4: { halign: "right", cellWidth: 22 },
        5: { halign: "center", cellWidth: 26 },
        6: { halign: "right", cellWidth: 22 }
      },
      styles: {
        fontSize: 8,
        cellPadding: 3
      },
      didParseCell: function (data) {
        if (data.row.index === tableBody.length - 1) {
          data.cell.styles.fillColor = [245, 245, 245];
        }
      }
    });

    const finalY = doc.lastAutoTable.finalY + 10;

    // 5. Bottom Sections
    let currY = finalY;
    doc.setFont("Helvetica", "bold");
    doc.text("Description", 15, currY);
    doc.setFont("Helvetica", "normal");
    currY += 5;
    doc.text(`Repair support for ${device}`, 15, currY);
    doc.text(`IMEI: ${imei}`, 15, currY + 4);

    doc.setFont("Helvetica", "bold");
    doc.text("Amount In Words", 15, currY + 12);
    doc.setFont("Helvetica", "normal");
    const roundedTotal = Math.round(totalWithGST);
    doc.text(numberToWords(roundedTotal), 15, currY + 17);

    doc.setFont("Helvetica", "bold");
    doc.text("Terms and Conditions", 15, currY + 25);
    doc.setFont("Helvetica", "normal");
    doc.text("1. E.&O.E.", 15, currY + 30);

    // Right Section: Summary Box
    const boxX = 125;
    const boxWidth = 70;
    let boxY = finalY;

    // Subtotal Row
    doc.rect(boxX, boxY, boxWidth, 7);
    doc.setFont("Helvetica", "normal");
    doc.text("Sub Total", boxX + 5, boxY + 5);
    doc.text("Rs. " + subTotal.toFixed(2), boxX + boxWidth - 5, boxY + 5, { align: "right" });
    boxY += 7;

    // IGST Row
    doc.rect(boxX, boxY, boxWidth, 7);
    doc.text(`IGST@18%`, boxX + 5, boxY + 5);
    doc.text("Rs. " + totalGst.toFixed(2), boxX + boxWidth - 5, boxY + 5, { align: "right" });
    boxY += 7;

    // Roundoff Row
    const roundOffVal = roundedTotal - totalWithGST;
    doc.rect(boxX, boxY, boxWidth, 7);
    doc.text("Round off", boxX + 5, boxY + 5);
    doc.text((roundOffVal >= 0 ? "+ " : "- ") + "Rs. " + Math.abs(roundOffVal).toFixed(2), boxX + boxWidth - 5, boxY + 5, { align: "right" });
    boxY += 7;

    // Total Row (Maroon Banner)
    doc.setFillColor(92, 37, 24);
    doc.rect(boxX, boxY, boxWidth, 8, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFont("Helvetica", "bold");
    doc.text("Total", boxX + 5, boxY + 5.5);
    doc.text("Rs. " + roundedTotal.toFixed(2), boxX + boxWidth - 5, boxY + 5.5, { align: "right" });

    // Received Row
    boxY += 8;
    doc.setTextColor(0, 0, 0);
    doc.setFont("Helvetica", "normal");
    doc.rect(boxX, boxY, boxWidth, 7);
    doc.text("Received", boxX + 5, boxY + 5);
    doc.text("Rs. 0.00", boxX + boxWidth - 5, boxY + 5, { align: "right" });
    boxY += 7;

    // Balance Row
    doc.rect(boxX, boxY, boxWidth, 7);
    doc.text("Balance", boxX + 5, boxY + 5);
    doc.text("Rs. " + roundedTotal.toFixed(2), boxX + boxWidth - 5, boxY + 5, { align: "right" });

    // Signature Area
    let sigY = boxY + 18;
    doc.setFont("Helvetica", "normal");
    doc.setFontSize(8);
    doc.text(`For : ${vendor.name}`, boxX + 5, sigY);

    // Draw Stamp
    const stampX = boxX + boxWidth / 2 - 10;
    const stampY = sigY + 12;
    doc.setDrawColor(0, 51, 153);
    doc.setLineWidth(0.8);
    doc.circle(stampX, stampY, 12);

    doc.setTextColor(0, 51, 153);
    doc.setFontSize(5);
    doc.setFont("Helvetica", "bold");
    doc.text("CHITRANSH", stampX, stampY - 3, { align: "center" });

    doc.setFontSize(7);
    doc.setFont("Helvetica", "oblique");
    doc.text("Honey", stampX, stampY + 1, { align: "center" });

    doc.setFontSize(5);
    doc.setFont("Helvetica", "bold");
    doc.text("ENTERPRISES", stampX, stampY + 5, { align: "center" });

    doc.setTextColor(0, 0, 0);
    doc.setFontSize(8);
    doc.setFont("Helvetica", "bold");
    doc.text("Authorized Signatory", boxX + 5, sigY + 28);

    if (shouldSave) {
      doc.save(`Invoice_${aaNumber}.pdf`);
    }
    return doc;
  };

  const { filteredInvoices, totalFilteredCount } = useMemo(() => {
    const originalInvoices = invoices.filter(inv =>
      !inv.isNewlyAdded && selectedBatchData?.aaNo?.split(',').map(a => a.trim()).includes(inv.aA_Number)
    );

    let newlyAddedInvoices = invoices.filter(inv => inv.isNewlyAdded);

    if (fromDate && toDate && newlyAddedInvoices.length > 0) {
      const parseInputDate = (dateStr) => {
        const [year, month, day] = dateStr.split("-").map(Number);
        return new Date(year, month - 1, day);
      };

      const parseInvoiceDate = (dateStr) => {
        if (!dateStr || typeof dateStr !== "string") return null;
        const [datePart] = dateStr.split(" ");
        const [day, month, year] = datePart.split("-").map(Number);
        return new Date(year, month - 1, day);
      };

      const from = parseInputDate(fromDate);
      const to = parseInputDate(toDate);
      to.setDate(to.getDate() + 1);

      newlyAddedInvoices = newlyAddedInvoices.filter((invoice) => {
        const dateField = filterType === "creation"
          ? invoice.creationDate
          : invoice.closureDate;

        if (!dateField) return false;
        const invoiceDate = parseInvoiceDate(dateField);
        return invoiceDate && invoiceDate >= from && invoiceDate < to;
      });
    }

    if (aaNumber && newlyAddedInvoices.length > 0) {
      newlyAddedInvoices = newlyAddedInvoices.filter((inv) =>
        inv.aA_Number?.toLowerCase().includes(aaNumber.toLowerCase())
      );
    }

    const result = [...originalInvoices, ...newlyAddedInvoices];

    return {
      filteredInvoices: result,
      totalFilteredCount: result.length
    };
  }, [invoices, fromDate, toDate, filterType, aaNumber, selectedBatchData]);
  useEffect(() => {
    const getTodayDate = () => {
      const today = new Date();
      return today.toISOString().split('T')[0];
    };

    const get30DaysAgoDate = () => {
      const thirtyDaysAgo = new Date();
      thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
      return thirtyDaysAgo.toISOString().split('T')[0];
    };

    if (showFilter && !fromDate && !toDate) {
      setFromDate(get30DaysAgoDate());
      setToDate(getTodayDate());
    }
  }, [showFilter, fromDate, toDate]);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(filteredInvoices.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentInvoices = filteredInvoices.slice(indexOfFirstItem, indexOfLastItem);

  console.log(filteredInvoices, 'jjjwwwww')
  const selectedAAno = invoices.filter((invoice) => invoice.isChecked);

  const totalRepairCharges = selectedAAno.reduce((total, invoice) => {
    const cleanedAmount = invoice.repairCharges?.toString().replace(/,/g, "");
    const amount = parseFloat(cleanedAmount);
    return total + (isNaN(amount) ? 0 : amount);
  }, 0);

  const totalServiceCharges = selectedAAno.reduce((total, invoice) => {
    const cleanedAmount = invoice.serviceCharges?.toString().replace(/,/g, "");
    const amount = parseFloat(cleanedAmount);
    return total + (isNaN(amount) ? 0 : amount);
  }, 0);
  const leftSideTotalRepairCharges = selectedAAno.reduce((total, invoice) => {
    const cleanedAmount = invoice.repairCharges?.toString().replace(/,/g, "");
    const amount = parseFloat(cleanedAmount);
    return total + (isNaN(amount) ? 0 : amount);
  }, 0);

  const leftSideTotalServiceCharges = selectedAAno.reduce((total, invoice) => {
    const cleanedAmount = invoice.serviceCharges?.toString().replace(/,/g, "");
    const amount = parseFloat(cleanedAmount);
    return total + (isNaN(amount) ? 0 : amount);
  }, 0);

  const leftSideGstAmount = isGSTApplied
    ? (leftSideTotalServiceCharges * 0.18).toFixed(2)
    : (0).toFixed(2);

  const leftSideGrossAmount = leftSideTotalRepairCharges + leftSideTotalServiceCharges;
  const leftSideFinalAmount = isGSTApplied
    ? (leftSideGrossAmount + parseFloat(leftSideGstAmount)).toFixed(2)
    : leftSideGrossAmount.toFixed(2);

  const leftSideTotalservicechargewithGST = (leftSideTotalServiceCharges + parseFloat(leftSideGstAmount)).toFixed(2);
  const leftSideCaseCount = selectedAAno.length;

  const gstAmount = isGSTApplied
    ? (totalServiceCharges * 0.18).toFixed(2)
    : (0).toFixed(2);

  const grossAmount = totalRepairCharges + totalServiceCharges;

  const finalAmount = isGSTApplied
    ? (grossAmount + parseFloat(gstAmount)).toFixed(2)
    : grossAmount.toFixed(2);

  const totalservicechargewithGST = (totalServiceCharges + parseFloat(gstAmount)).toFixed(2);

  const formatDate = (dateTimeStr) => {
    if (!dateTimeStr || typeof dateTimeStr !== "string") return "--";

    if (!isNaN(dateTimeStr)) {
      const serial = parseFloat(dateTimeStr);
      const utc_days = Math.floor(serial - 25569);
      const utc_value = utc_days * 86400;
      const date_info = new Date(utc_value * 1000);
      return date_info.toLocaleDateString("en-GB"); // DD/MM/YYYY
    }

    const [datePart] = dateTimeStr.split(" ");
    if (!datePart.includes("-")) return "--";

    const [day, month, year] = datePart.split("-");
    if (!day || !month || !year) return "--";

    return `${day}/${month}/${year}`;
  };
  const formatINVOICEDate = (dateStr) => {
    if (!dateStr || typeof dateStr !== "string") return "";

    if (dateStr.includes("/") || dateStr.includes("-")) {
      const normalized = dateStr.replaceAll("/", "-");
      const parts = normalized.split("-");

      if (parts[0].length === 4) {
        return `${parts[0]}-${parts[1].padStart(2, "0")}-${parts[2].padStart(2, "0")}`;
      }

      if (parts[2].length === 4) {
        return `${parts[2]}-${parts[1].padStart(2, "0")}-${parts[0].padStart(2, "0")}`;
      }
    }

    return "";
  };


  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  useEffect(() => {
    setCurrentPage(1);
  }, [fromDate, toDate, aaNumber, filterType]);

  const handleViewClick = (aaNumber) => {
    sessionStorage.setItem('preserveInvoices', 'true');
    navigate("/invoice-template", { state: { aaNumber } });
  };

  const handleBackClick = () => {
    localStorage.removeItem("invoices");
    navigate(-1);
  };
  useEffect(() => {
    return () => {
      if (sessionStorage.getItem('preserveInvoices') !== 'true') {
        localStorage.removeItem("invoices");
      }
      sessionStorage.removeItem('preserveInvoices');
    };
  }, []);

  useEffect(() => {
    if (!selectedBatchData) {
      navigate("/invoice");
      return;
    }
    const originalCaseCountVal = selectedBatchData.caseCount
      ? selectedBatchData.caseCount.toString()
      : "";
    const originalInvoiceAmountVal = selectedBatchData.invoiceAmount
      ? selectedBatchData.invoiceAmount.toString()
      : "";

    setOriginalCaseCount(originalCaseCountVal);
    setOriginalInvoiceAmount(originalInvoiceAmountVal);
    setRightSideCaseCount(originalCaseCountVal);
    setRightSideInvoiceAmount(originalInvoiceAmountVal);

    setInvoiceNo(selectedBatchData.invoiceNo || "");
    setInvoiceDate(formatINVOICEDate(selectedBatchData.invoiceDate) || "");
    setInvoiceAmount(
      selectedBatchData.invoiceAmount
        ? selectedBatchData.invoiceAmount.toString()
        : ""
    );
    setCaseCount(
      selectedBatchData.caseCount ? selectedBatchData.caseCount.toString() : ""
    );
    if (!selectedBatchData.gst || selectedBatchData.gst === "0.00") {
      setIsGSTApplied(false);
    } else {
      setIsGSTApplied(true);
    }
    setIsLoading(true);
    if (selectedBatchData.aaNo) {
      const aaNumbers = selectedBatchData.aaNo
        .split(",")
        .map((val) => val.trim());

      Promise.all(
        aaNumbers.map((aaNo) =>
          fetch(`${BASE_URL}/GetGadgetCaseDetailsByAA?aaNumbers=${aaNo}`)
            .then((response) => {
              if (!response.ok) {
                console.error(
                  `HTTP error for aaNo ${aaNo}: ${response.status}`
                );
                return null;
              }
              return response.json();
            })
            .then((responseData) => {
              if (!responseData || responseData.status === false) {
                return { status: false, aA_Number: aaNo, dataItems: [] };
              }
              const remarkFileUrl =
                responseData?.dataItems?.[0]?.remarkFileUrl || null;
              const remarks =
                responseData?.dataItems?.[0]?.remarks || null;

              return {
                status: responseData.status,
                aA_Number: aaNo,
                dataItems: Array.isArray(responseData.dataItems)
                  ? responseData.dataItems
                  : [],
                remarkFileUrl, remarks
              };

            })
            .catch((error) => {
              console.error(`Error fetching API data for ${aaNo}:`, error);
              return [];
            })
        )
      )
        .then((results) => {
          const combinedData = results.flat().filter((item) => item);
          setApiData(combinedData);
        })
        .catch((error) => {
          console.error("Error in Promise.all:", error);
          setApiData([]);
        })
        .finally(() => setIsLoading(false));
    } else {
      setIsLoading(false);
    }
  }, [selectedBatchData, navigate]);

  const handleRightSideCaseCountChange = (value) => {
    setRightSideCaseCount(value);
    setFieldErrors((prev) => ({
      ...prev,
      caseCount: !value.trim() || isNaN(value) || parseInt(value) <= 0,
    }));
  };

  const handleRightSideInvoiceAmountChange = (value) => {
    setRightSideInvoiceAmount(value);
    setFieldErrors((prev) => ({
      ...prev,
      invoiceAmount: !value.trim() || isNaN(value) || parseFloat(value) <= 0,
    }));

    // Clear amount error when user types
    setAmountError("");
  };
  useEffect(() => {
    if (!selectedBatchData) return;

    const splitData = (key) =>
      selectedBatchData[key]?.split(",").map((val) => val.trim()) || [];

    const invoicesArray = splitData("aaNo").map((_, i) => {
      const remarkFileUrl = splitData("remarkFile")[i];
      const documentFileUrl = splitData("documentFileUrl")[i];
      const billingType = splitData("billingType")[i];
      return {
        aA_Number: splitData("aaNo")[i],
        imeiNumber: splitData("imeiNo")[i],
        creationDate: splitData("creationDate")[i],
        closureDate: splitData("closureDate")[i],
        customerName: splitData("customerName")[i],
        serviceType: splitData("serviceType")[i],
        brand: splitData("brand")[i],
        makeModel: splitData("makeModel")[i],
        repairCharges: splitData("repairCharges")[i]
          ? parseFloat(splitData("repairCharges")[i]).toFixed(2)
          : "0.00",
        serviceCharges: splitData("serviceCharges")[i]
          ? parseFloat(splitData("serviceCharges")[i]).toFixed(2)
          : "0.00",
        total: splitData("total")[i]
          ? parseFloat(splitData("total")[i]).toFixed(2)
          : "0.00",
        invoiceStatus: selectedBatchData.invoiceStatus || "-",
        sellingPartner: splitData("sellingPartner")[i],
        batchNo: selectedBatchData.batchNo || "",
        isChecked: true,
        remarks: splitData("remarks")[i] || "",
        remarkFileUrl: remarkFileUrl || null,
        isNewlyAdded: false,
        isEdited: false,
        billingType: billingType || "-",
        documentFileUrl: documentFileUrl || null

      };
    });

    // Apply any local edits from localStorage
    const storedInvoices = JSON.parse(localStorage.getItem("invoices") || "[]");
    const mergedWithLocal = invoicesArray.map((invoice) => {
      const stored = storedInvoices.find(
        (item) => item.aA_Number === invoice.aA_Number
      );
      return stored
        ? {
          ...invoice,
          serviceCharges: stored.serviceCharges,
          repairCharges: stored.repairCharges,
          total: stored.total,
          chargesInclGST: stored.chargesInclGST,
          remarks: stored.remarks || invoice.remarks,
          remarkFileUrl: stored.remarkFile || invoice.remarkFileUrl,
          isEdited: stored.isEdited !== undefined ? stored.isEdited : false,
          billingType: stored.billingType || "billing",
        }
        : invoice;
    });

    // Merge with API data but preserve batch charges
    const mergedWithApi = mergedWithLocal.map((invoice) => {
      const apiMatch = apiData?.find(
        (apiItem) => apiItem?.aA_Number === invoice.aA_Number
      );
      if (!apiMatch) return invoice;

      const system = apiMatch.dataItems?.[0] || {};

      return {
        ...invoice,
        // Preserve batch charges and other data
        remarks: system.remarks || apiMatch.remarks || invoice.remarks,
        remarkFileUrl: system.remarkFileUrl || apiMatch.remarkFileUrl || invoice.remarkFileUrl,
        documentFileUrl: system.documentFileUrl || apiMatch.documentFileUrl || invoice.documentFileUrl || null,
        billingType: system.billingType || apiMatch.billingType || invoice.billingType || "billing",
        // Keep batch data for charges and other fields
      };
    });

    setInvoices((prevInvoices) => {
      const existingAA = new Set(mergedWithApi.map((i) => i.aA_Number));
      const vendorAddedInvoices = prevInvoices.filter(
        (i) => !existingAA.has(i.aA_Number)
      );
      return [...mergedWithApi, ...vendorAddedInvoices].filter(
        (inv) => !deletedAANumbers.includes(inv.aA_Number?.toString().trim())
      );
    });
  }, [selectedBatchData, apiData, deletedAANumbers]);
  const normalize = (value) =>
    (value ? value.toString().trim() : "").toLowerCase();
  const getSystemValue = (matchedData, key) =>
    matchedData?.dataItems?.[0]?.[key] ?? matchedData?.[key] ?? "";

  const getRowClassName = useCallback(
    (invoice) => {
      if (!Array.isArray(apiData)) return "row-red";

      const matchedData = apiData.find(item => item?.aA_Number === invoice.aA_Number);
      if (!matchedData) return "row-red";

      const getSystemValue = (key) =>
        matchedData?.dataItems?.[0]?.[key] ?? matchedData?.[key] ?? "";

      const compareKeys = ["serviceType", "repairCharges", "serviceCharges", "total"];

      for (let key of compareKeys) {
        const invoiceVal = invoice[key] ? invoice[key].toString().trim() : "";
        const apiVal = getSystemValue(key) ? getSystemValue(key).toString().trim() : "";
        if (invoiceVal !== apiVal) return "row-yellow"; // mismatch
      }

      return "row-green"; // all matches
    },
    [apiData]
  );
  const getDifferencesData = (invoice) => {
    const matchedData = apiData.find(
      (item) => item && item.aA_Number === invoice.aA_Number
    );
    if (!matchedData)
      return [{ field: "AA Number", table: invoice.aA_Number, api: "-" }];

    const getSystemValue = (key) =>
      matchedData?.dataItems?.[0]?.[key] ?? matchedData?.[key] ?? "";

    const differences = [];

    if (normalize(getSystemValue("serviceType")) !== normalize(invoice.serviceType)) {
      differences.push({
        field: "Service Type",
        table: invoice.serviceType || "",
        api: getSystemValue("serviceType") || "",
      });
    }

    if (normalize(getSystemValue("imeiNumber")) !== normalize(invoice.imeiNumber)) {
      differences.push({
        field: "IMEI Number",
        table: invoice.imeiNumber || "",
        api: getSystemValue("imeiNumber") || "",
      });
    }

    if (normalize(getSystemValue("repairCharges")) !== normalize(invoice.repairCharges)) {
      differences.push({
        field: "Repair Charges",
        table: invoice.repairCharges || "",
        api: getSystemValue("repairCharges") || "",
      });
    }

    if (normalize(getSystemValue("serviceCharges")) !== normalize(invoice.serviceCharges)) {
      differences.push({
        field: "Service Charges",
        table: invoice.serviceCharges || "",
        api: getSystemValue("serviceCharges") || "",
      });
    }

    if (normalize(getSystemValue("total")) !== normalize(invoice.total)) {
      differences.push({
        field: "Total Amount",
        table: invoice.total || "",
        api: getSystemValue("total") || "",
      });
    }

    return differences;
  };
  const handleDelete = (aaNumber) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setOpenRemarkModal(true);
        setSelectedInvoiceIndex(aaNumber);
      }
    });
  };

  const handleSubmitRemark = async () => {
    if (!remarks.trim()) {
      Swal.fire("Error", "Please enter a remark.", "warning");
      return;
    }

    try {
      const allAANumbers = invoices.map((inv) => inv.aA_Number).join(",");

      const formData = new FormData();
      formData.append("aA_Number", allAANumbers);
      formData.append("remarks", `AANumber-${selectedInvoiceIndex} Deleted: ${remarks}`);
      formData.append("remarkAndLogBy", user.role);
      formData.append("batchNo", selectedBatchData.batchNo);
      formData.append("DeletedAA", selectedInvoiceIndex);

      formData.append("logs", `AANumber-${selectedInvoiceIndex} Deleted from Batch NO:${selectedBatchData.batchNo}`);

      const remarkRes = await fetch(`${BASE_URL}/InsertLogsAndRemarksTracking`, {
        method: "POST",
        body: formData,
      });

      if (!remarkRes.ok) {
        Swal.fire("Error", "Failed to save remark.", "error");
        return;
      }

      const deleteRes = await fetch(`${BASE_URL}/ResetGadgetCaseDetails`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ aA_Number: selectedInvoiceIndex }),
      });

      const deleteData = await deleteRes.json();

      if (!deleteRes.ok || !deleteData.status) {
        Swal.fire("Error", deleteData.message || "Failed to delete record.", "error");
        return;
      }

      const updatedInvoices = invoices.filter(
        (inv) => inv.aA_Number.toString().trim() !== selectedInvoiceIndex.toString().trim()
      );
      setInvoices(updatedInvoices);
      setDeletedAANumbers((prev) => [...prev, selectedInvoiceIndex]);
      setRowDeleted(true);

      await Swal.fire("Deleted!", "Your record has been deleted.", "success");

      setOpenRemarkModal(false);
      setRemarks("");
      setSelectedInvoiceIndex(null);
      // await handleSaveData(updatedInvoices);
    } catch (error) {
      console.error("Error:", error);
      Swal.fire("Error", "Something went wrong. Please try again.", "error");
    }
  };

  useEffect(() => {
    if (rowDeleted) {
      setRightSideCaseCount(leftSideCaseCount);
      setRightSideInvoiceAmount(leftSideFinalAmount);
    }
  }, [rowDeleted, leftSideCaseCount, leftSideFinalAmount]);

  const handleCheckboxChange = (invoiceId) => {
    setInvoices((prevInvoices) =>
      prevInvoices.map((invoice) =>
        invoice.aA_Number === invoiceId
          ? { ...invoice, isChecked: !invoice.isChecked }
          : invoice
      )
    );
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };
  const handleAddAAnumber = async () => {
    setShowAaNumber(true)
    if (!selectedBatchData?.vendorName) {
      alert("Vendor name is required!");
      return;
    }

    try {
      setIsLoading(true);
      const response = await fetch(
        `${BASE_URL}/GetGadgetCaseDetailsByVendor?vendorName=${encodeURIComponent(
          selectedBatchData.vendorName
        )}`
      );
      const data = await response.json();

      if (data.status && Array.isArray(data.dataItems)) {
        const newInvoices = data.dataItems.map((item) => {
          const aaNumber = item.aA_Number || item.aaNumber || "-";

          return {
            aA_Number: aaNumber,
            imeiNumber: item.imeiNumber || "-",
            creationDate: item.creationDate || "-",
            closureDate: item.closureDate || "-",
            customerName: item.customerName || "-",
            serviceType: item.serviceType || "-",
            brand: item.brand || "-",
            makeModel: item.makeModel || "-",
            repairCharges: item.repairCharges ? parseFloat(item.repairCharges).toFixed(2) : "0.00",
            serviceCharges: item.serviceCharges ? parseFloat(item.serviceCharges).toFixed(2) : "0.00",
            total: item.total ? parseFloat(item.total).toFixed(2) : "0.00",
            invoiceStatus: "Batch Created",
            sellingPartner: item.sellingPartner || "-",
            batchNo: selectedBatchData.batchNo || "",
            isChecked: false,
            remarks: item.remarks || "",
            remarkFileUrl: item.remarkFileUrl || null,
            isNewlyAdded: true,
            isEdited: false,
            documentFileUrl: item.documentFileUrl || null,
            billingType: item.billingType || "-"

          };
        });

        const existingAANumbers = new Set(invoices.map(inv => inv.aA_Number));
        const uniqueNewInvoices = newInvoices.filter(inv => !existingAANumbers.has(inv.aA_Number));

        if (uniqueNewInvoices.length === 0) {
          alert("No new AA numbers found for this vendor.");
          return;
        }

        setInvoices(prev => [...prev, ...uniqueNewInvoices]);

        setApiData(prev => {
          const newApiData = uniqueNewInvoices.map(invoice => ({
            status: true,
            aA_Number: invoice.aA_Number,
            dataItems: [{
              serviceType: invoice.serviceType,
              imeiNumber: invoice.imeiNumber,
              repairCharges: invoice.repairCharges,
              serviceCharges: invoice.serviceCharges,
              total: invoice.total,
              remarks: "",
              remarkFileUrl: null
            }],
            remarkFileUrl: null,
            remarks: ""
          }));
          return [...prev, ...newApiData];
        });

        setFromDate("");
        setToDate("");
        setAaNumber("");
        setCurrentPage(1);
        setShowFilter(true);

        toast.success(`Added ${uniqueNewInvoices.length} new AA numbers`);
      } else {
        console.error("Failed to fetch AA numbers:", data.message);
        alert("No AA numbers found for this vendor.");
      }
    } catch (err) {
      console.error("Error fetching AA numbers:", err);
      alert("Something went wrong while fetching AA numbers.");
    } finally {
      setIsLoading(false);
    }
  };

  const areArraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    return arr1.every(
      (item, index) => item.aA_Number === arr2[index].aA_Number
    );
  };

  useEffect(() => {
    if (currentInvoices.length === 0) return;

    if (!areArraysEqual(currentInvoices, previousInvoices)) {
      setIsLoading(true);
      const aaNumbers = currentInvoices
        .map((invoice) => invoice.aA_Number)
        .join(",");

      fetch(`${BASE_URL}/GetGadgetCaseDetailsByAA?aaNumbers=${aaNumbers}`)
        .then((response) => response.json())
        .then((responseData) => {
          if (Array.isArray(responseData.dataItems)) {
            const newApiData = responseData.dataItems.map(item => ({
              status: true,
              aA_Number: item.aA_Number,
              dataItems: [item],
              remarkFileUrl: item.remarkFileUrl || null,
              remarks: item.remarks || null
            }));

            setApiData(prev => {
              const updatedApiData = [...prev];
              newApiData.forEach(newItem => {
                const existingIndex = updatedApiData.findIndex(item => item.aA_Number === newItem.aA_Number);
                if (existingIndex >= 0) {
                  updatedApiData[existingIndex] = newItem;
                } else {
                  updatedApiData.push(newItem);
                }
              });
              return updatedApiData;
            });

            // Only update remarks and files, preserve batch charges
            setInvoices(prevInvoices => {
              return prevInvoices.map(invoice => {
                const updatedItem = responseData.dataItems.find(item => item.aA_Number === invoice.aA_Number);
                if (updatedItem) {
                  return {
                    ...invoice,
                    // Preserve all batch data including charges
                    remarks: updatedItem.remarks || invoice.remarks,
                    remarkFileUrl: updatedItem.remarkFileUrl || invoice.remarkFileUrl,
                    documentFileUrl: updatedItem.documentFileUrl || invoice.documentFileUrl,
                    billingType: updatedItem.billingType || invoice.billingType,
                    // Don't update charges from API - keep batch data
                  };
                }
                return invoice;
              });
            });
          } else {
            setApiData([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching API data:", error);
          setApiData([]);
        })
        .finally(() => setIsLoading(false));

      setPreviousInvoices(currentInvoices);
    }
  }, [currentInvoices, previousInvoices]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const extension = file.name.split(".").pop().toLowerCase();
    const allowedExtensions = ["csv", "pdf", "jpg", "jpeg", "png"];

    if (!allowedExtensions.includes(extension)) {
      toast.error("Only CSV, PDF, JPG, and PNG files are allowed.");
      return;
    }

    setFileType(extension);
    setUploadedFile(file);
    setFieldErrors((prev) => ({ ...prev, uploadedFile: false }));

    if (extension === "csv") {
      Papa.parse(file, {
        header: true,
        complete: (results) => {
          const row = results.data[0];
          setInvoiceNo(row["Invoice No"] || selectedBatchData.invoiceNo || "");
          setInvoiceDate(
            formatDate(row["Invoice Date"]) || selectedBatchData.invoiceDate || ""
          );
          setInvoiceAmount(
            row["Invoice Amount"]
              ? row["Invoice Amount"].toString()
              : selectedBatchData.invoiceAmount
                ? selectedBatchData.invoiceAmount.toString()
                : ""
          );
          setCaseCount(
            row["Case Count"]
              ? row["Case Count"].toString()
              : selectedBatchData?.caseCount
                ? selectedBatchData?.caseCount.toString()
                : ""
          );
        },
        error: (err) => {
          console.error("CSV parsing error:", err);
          toast.error("Failed to read CSV file.");
        },
      });
    }
  };

  const downloadCSV = () => {
    const headers = [
      "AANumber",
      "IMEINumber",
      "CustomerName",
      "Brand",
      "MakeModel",
      "RepairCharges",
      "ServiceCharges (Pre GST)",
      "Total",
      "CreationDate",
      "ClosureDate",
      // "InvoiceStatus",
      // "Remarks",
      // "RemarkFile",
      // "Remarks",
      // "Remark File",
    ];

    const today = new Date().toLocaleDateString("en-GB");
    function formatDate(value) {
      if (!value) return "";

      let str = String(value).trim();

      str = str.split(" ")[0].split("T")[0];

      str = str.replace(/\./g, "-").replace(/\//g, "-");

      const parts = str.split("-");
      if (parts.length === 3) {
        if (parts[0].length === 4) {
          return `${parts[2].padStart(2, "0")}/${parts[1].padStart(2, "0")}/${parts[0]}`;
        } else {
          return `${parts[0].padStart(2, "0")}/${parts[1].padStart(2, "0")}/${parts[2]}`;
        }
      }
      const d = new Date(value);
      if (!isNaN(d)) return d.toLocaleDateString("en-GB");

      return value;
    }

    const data = selectedAAno.map((invoice) => ({

      aaNumber: invoice.aA_Number || "",
      imeiNumber: invoice.imeiNumber ? `${invoice.imeiNumber}` : "",

      customerName: invoice.customerName || "",
      // serviceType: invoice.serviceType || "",
      brand: invoice.brand || "",
      makeModel: invoice.makeModel || "",
      repairCharges: invoice.repairCharges || "0.00",
      serviceCharges: invoice.serviceCharges || "0.00",
      total: invoice.total || "0.00",
      creationDate: formatDate(invoice.creationDate) || "",
      closureDate: formatDate(invoice.closureDate) || "",
      // invoiceStatus: invoice.invoiceStatus || "",
      // remarks: invoice.remarks || "",
      // remarkFile: invoice.remarkFile
      //   ? invoice.remarkFile.name || invoice.remarkFile
      //   : "",

    }));

    const csv = Papa.unparse({
      fields: headers,
      data: data.map(row => Object.values(row)),
    }, {
      quotes: true,
      quoteChar: '"',
      delimiter: ',',
      newline: '\r\n'
    });

    const vendorName =
      selectedAAno?.[0]?.sellingPartner?.replace(/\s+/g, "_") || "invoice";

    const fileName = `${vendorName}_list.csv`;

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, fileName);
  };

  const parseDateFlexible = (dateStr) => {
    if (!dateStr) return null;

    try {

      if (dateStr instanceof Date) return dateStr;
      if (!isNaN(dateStr)) return new Date(parseInt(dateStr));

      let datePart = dateStr.split(' ')[0];
      datePart = datePart.split('T')[0];
      let parts;

      if (datePart.includes('-')) {
        parts = datePart.split('-').map(Number);
        if (parts[0] > 31) {
          return new Date(parts[0], parts[1] - 1, parts[2]);
        } else {
          return new Date(parts[2], parts[1] - 1, parts[0]);
        }
      } else if (datePart.includes('/')) {
        parts = datePart.split('/').map(Number);
        if (parts[0] > 12) {
          return new Date(parts[2], parts[1] - 1, parts[0]);
        } else {
          return new Date(parts[2], parts[0] - 1, parts[1]);
        }
      }

      const date = new Date(dateStr);
      return isNaN(date.getTime()) ? null : date;
    } catch (error) {
      console.error('Error parsing date:', dateStr, error);
      return null;
    }
  };

  const validateInvoiceDate = (selectedInvoices, invoiceDate) => {
    const invoiceDt = parseDateFlexible(invoiceDate);
    if (!invoiceDt || isNaN(invoiceDt.getTime())) {
      return { isValid: false, error: "Invalid Invoice Date." };
    }

    const today = new Date();
    today.setHours(23, 59, 59, 999);

    if (invoiceDt > today) {
      return { isValid: false, error: "Invoice Date cannot be a future date." };
    }

    let maxClosureDate = null;

    selectedInvoices.forEach(invoice => {
      if (!invoice.isChecked) return;

      const closureRaw = invoice.closureDate;
      const closureDate = parseDateFlexible(closureRaw);

      if (closureDate && !isNaN(closureDate.getTime())) {
        if (!maxClosureDate || closureDate > maxClosureDate) {
          maxClosureDate = closureDate;
        }
      }
    });

    console.log('Latest Closure Date:', maxClosureDate);
    console.log('Invoice Date:', invoiceDt);

    if (maxClosureDate && invoiceDt < maxClosureDate) {
      return {
        isValid: false,
        error: `Invoice Date (${invoiceDt.toLocaleDateString()}) cannot be earlier than the latest Closure Date (${maxClosureDate.toLocaleDateString()}).`
      };
    }

    return { isValid: true };
  };

  const handleSubmit = async () => {
    try {
      const selected = invoices.filter((inv) => inv.isChecked);
      if (selected.length === 0) {
        toast.error("Please select at least one invoice.");
        return;
      }

      // Check if all newly added invoices are edited
      const uneditedNewlyAdded = invoices.filter((inv) => inv.isNewlyAdded && !inv.isEdited);
      if (uneditedNewlyAdded.length > 0) {
        toast.error("Please edit all newly added AA number rows before submitting.");
        return;
      }

      const newErrors = {
        invoiceNo: false,
        invoiceDate: false,
        invoiceAmount: false,
        caseCount: false,
        uploadedFile: false,
        remarks: {},
      };

      let hasRemarkError = false;
      selected.forEach((invoice) => {
        const isYellowRow = getRowClassName(invoice) === "row-yellow";
        const isRemarkEmpty = !invoice.remarks?.trim();
        if (isYellowRow && isRemarkEmpty) {
          newErrors.remarks[invoice.aA_Number] = true;
          hasRemarkError = true;
        } else {
          newErrors.remarks[invoice.aA_Number] = false;
        }
      });

      setFieldErrors(newErrors);

      if (hasRemarkError) {
        toast.error(
          "Remarks are required for all yellow rows (mismatched data)."
        );
        return;
      }

      // ==== DATE VALIDATION START ====
      const dateValidation = validateInvoiceDate(selected, invoiceDate);
      if (!dateValidation.isValid) {
        setFieldErrors((prev) => ({ ...prev, invoiceDate: true }));
        toast.error(dateValidation.error);
        return;
      }
      // ==== DATE VALIDATION END ====

      let hasMismatch = false;
      for (const invoice of selected) {
        const matchedData = invoices.find(
          (item) => item.aA_Number === invoice.aA_Number
        );
        if (!matchedData) {
          toast.error(
            `AA Number ${invoice.aA_Number} not found in reference data. Please delete the row or check the source.`
          );
          return;
        }

        if (
          normalize(matchedData.serviceType) !==
          normalize(invoice.serviceType) ||
          normalize(matchedData.repairCharges) !==
          normalize(invoice.repairCharges) ||
          normalize(matchedData.serviceCharges) !==
          normalize(invoice.serviceCharges) ||
          normalize(matchedData.total) !== normalize(invoice.total)
        ) {
          hasMismatch = true;
        }
      }

      if (hasMismatch) {
        const confirmProceed = window.confirm(
          "Warning: Some invoice fields do not match the original data.\nDo you want to proceed anyway?"
        );
        if (!confirmProceed) return;
      }

      const formData = new FormData();
      const extract = (key) =>
        selected.map((item) => item[key] || "").join(", ");
      formData.append("AANo", extract("aA_Number"));
      formData.append("IMEINo", extract("imeiNumber"));
      formData.append("CreationDate", extract("creationDate"));
      formData.append("ClosureDate", extract("closureDate"));
      formData.append("CustomerName", extract("customerName"));
      formData.append("Remarks", extract("remarks"));
      formData.append("VendorName", selectedBatchData?.vendorName || "");
      formData.append("finalAmount", finalAmount);
      formData.append("TotalRepairCharges", totalRepairCharges.toFixed(2));
      formData.append("TotalServiceCharges", totalservicechargewithGST);
      formData.append("GST", gstAmount || "");
      formData.append("BatchNo", selectedBatchData?.batchNo || "");
      formData.append("ServiceType", extract("serviceType"));
      formData.append("Brand", extract("brand"));
      formData.append("MakeModel", extract("makeModel"));
      formData.append("RepairCharges", extract("repairCharges"));
      formData.append("ServiceCharges", extract("serviceCharges"));
      formData.append("Total", extract("total"));
      formData.append("SellingPartner", extract("sellingPartner"));
      formData.append("billingType", extract("billingType"));
      formData.append("documentFileUrl", extract("documentFileUrl"));
      // formData.append(
      //   "InvoiceStatus",
      //   uploadedFile || selectedBatchData?.invoice ? "Invoice Uploaded" : extract("invoiceStatus")
      // );
      formData.append("InvoiceStatus", "Billed");
      formData.append("InvoiceNo", invoiceNo);
      formData.append("InvoiceDate", invoiceDate);
      formData.append("InvoiceAmount", finalAmount);
      formData.append("CaseCount", selected.length.toString());
      formData.append("IsGSTApplied", isGSTApplied ? "true" : "false");

      if (selectedBatchData?.invoice) {
        const response = await fetch(selectedBatchData.invoice);
        const blob = await response.blob();
        const url = new URL(selectedBatchData.invoice);
        const filename = url.searchParams.get("fileName");
        formData.append("Invoice", blob, filename);
        console.log(filename, "testhththththt", uploadedFile)
      } else if (uploadedFile) {
        formData.append("Invoice", uploadedFile, uploadedFile.name);
      }

      const invoiceWithFile = selected.find((inv) => inv.remarkFile);
      if (invoiceWithFile) {
        const remark = invoiceWithFile.remarkFile;

        if (remark instanceof File) {
          formData.append("RemarkFile", remark, remark.name);
        } else if (remark?.url && typeof remark.url === "string") {
          const fileName = remark.name || "remark-file.pdf";
          try {
            const response = await fetch(remark.url);
            if (response.ok) {
              const blob = await response.blob();
              formData.append("RemarkFile", blob, fileName);
            } else {
              formData.append("RemarkFile", null);
            }
          } catch (err) {
            formData.append("RemarkFile", null);
          }
        } else {
          formData.append("RemarkFile", null);
        }
      } else {
        formData.append("RemarkFile", null);
      }

      setIsLoading(true);
      const response = await fetch(`${BASE_URL}/SaveApprovalBatchData`, {
        method: "POST",
        body: formData,
      });
      const result = await response.json();
      setIsLoading(false);

      if (!response.ok) {
        toast.error("Error submitting batch. Check the payload or try again.");
        return;
      }

      const aanoString = selected.map((item) => item.aA_Number).join(",");

      const remarkFormData = new FormData();
      remarkFormData.append("AANo", aanoString);
      remarkFormData.append("Remark", "Batch Submitted for Approval");
      remarkFormData.append("BatchNo", selectedBatchData.batchNo);
      remarkFormData.append("ByWhom", user?.role);
      try {
        const res = await fetch(`${BASE_URL}/UpdateRemarkAgainstBatch`, {
          method: "POST",
          body: remarkFormData,
        });
      } catch (remarkError) {
        console.error("Failed to update remarks:", remarkError);
      }
      localStorage.removeItem("invoices");

      Swal.fire({
        title: "✅ Batch Submitted for Approval",
        text: `Batch No: ${selectedBatchData?.batchNo || "-"} | Invoice No: ${invoiceNo}`,
        icon: "success",
        confirmButtonColor: "#7E00D1",
        confirmButtonText: "OK",
      }).then(async () => {
        setTimeout(async () => {
          try {
            const linkPayload = selected.map((item) => ({
              aA_Number: item.aA_Number,
              // invoiceStatus:
              //   uploadedFile || selectedBatchData?.invoice
              //     ? "Invoice Uploaded"
              //     : item.invoiceStatus,
              invoiceStatus: "Billed",
              batchNo: selectedBatchData?.batchNo || "",
              invoiceNumber: invoiceNo,
              invoiceDate: new Date(invoiceDate).toISOString(),
              invoiceAmount: parseFloat(finalAmount),
              invoice: selectedBatchData?.invoice
                ? selectedBatchData?.invoice
                : uploadedFile.name,
              financeStatus: "N/A",
            }));

            for (const payload of linkPayload) {
              await fetch(`${BASE_URL}/LinkOperationsToGadget`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
              });
            }
          } catch (error) {
            console.error("Error calling LinkOperationsToGadget API:", error);
          }

          navigate("/approval");
        }, 2000);
      });

      navigate("/approval");

    } catch (error) {
      console.error("Submission failed:", error);
      setIsLoading(false);
      toast.error("Submission failed. Please check console for details.");
    }
  };

  const handleSaveData = async () => {
    try {
      const selected = invoices.filter((inv) => inv.isChecked);

      if (selected.length === 0) {
        toast.error("Please select at least one invoice.");
        return;
      }

      // Check if all newly added invoices are edited
      const uneditedNewlyAdded = invoices.filter((inv) => inv.isNewlyAdded && !inv.isEdited);
      if (uneditedNewlyAdded.length > 0) {
        toast.error("Please edit all newly added AA number rows before saving.");
        return;
      }

      const newErrors = {
        invoiceNo: false,
        invoiceDate: false,
        invoiceAmount: false,
        caseCount: false,
        uploadedFile: false,
        remarks: {},
      };

      let hasRemarkError = false;
      selected.forEach((invoice) => {
        const isYellowRow = getRowClassName(invoice) === "row-yellow";
        const isRemarkEmpty = !invoice.remarks?.trim();
        if (isYellowRow && isRemarkEmpty) {
          newErrors.remarks[invoice.aA_Number] = true;
          hasRemarkError = true;
        } else {
          newErrors.remarks[invoice.aA_Number] = false;
        }
      });

      setFieldErrors(newErrors);

      if (hasRemarkError) {
        toast.error(
          "Remarks are required for all yellow rows (mismatched data)."
        );
        return;
      }

      const dateValidation = validateInvoiceDate(selected, invoiceDate);
      if (!dateValidation.isValid) {
        setFieldErrors((prev) => ({ ...prev, invoiceDate: true }));
        toast.error(dateValidation.error);
        return;
      }

      let hasMismatch = false;
      for (const invoice of selected) {
        const matchedData = invoices.find(
          (item) => item.aA_Number === invoice.aA_Number
        );
        if (!matchedData) {
          toast.error(
            `AA Number ${invoice.aA_Number} not found in reference data. Please delete the row or check the source.`
          );
          return;
        }

        if (
          normalize(matchedData.serviceType) !==
          normalize(invoice.serviceType) ||
          normalize(matchedData.repairCharges) !==
          normalize(invoice.repairCharges) ||
          normalize(matchedData.serviceCharges) !==
          normalize(invoice.serviceCharges) ||
          normalize(matchedData.total) !== normalize(invoice.total)
        ) {
          hasMismatch = true;
        }
      }

      if (hasMismatch) {
        const confirmProceed = window.confirm(
          "Warning: Some invoice fields do not match the original data.\nDo you want to proceed anyway?"
        );
        if (!confirmProceed) return;
      }

      const formData = new FormData();
      const extract = (key) =>
        selected.map((item) => item[key] || "").join(", ");

      formData.append("AANo", extract("aA_Number"));
      formData.append("IMEINo", extract("imeiNumber"));
      formData.append("CreationDate", extract("creationDate"));
      formData.append("ClosureDate", extract("closureDate"));
      formData.append("CustomerName", extract("customerName"));
      formData.append("Remarks", extract("remarks"));
      formData.append("VendorName", selectedBatchData?.vendorName || "");
      formData.append("finalAmount", finalAmount);
      formData.append("TotalRepairCharges", totalRepairCharges.toFixed(2));
      formData.append("TotalServiceCharges", totalservicechargewithGST);
      formData.append("GST", gstAmount || "");
      formData.append("BatchNo", selectedBatchData?.batchNo || "");
      formData.append("ServiceType", extract("serviceType"));
      formData.append("Brand", extract("brand"));
      formData.append("MakeModel", extract("makeModel"));
      formData.append("RepairCharges", extract("repairCharges"));
      formData.append("ServiceCharges", extract("serviceCharges"));
      formData.append("Total", extract("total"));
      formData.append("SellingPartner", extract("sellingPartner"));
      formData.append("InvoiceStatus", "Batch Created");
      formData.append("InvoiceNo", invoiceNo);
      formData.append("InvoiceDate", invoiceDate);
      formData.append("InvoiceAmount", finalAmount);
      formData.append("CaseCount", selected.length.toString());
      formData.append("IsGSTApplied", isGSTApplied ? "true" : "false");

      if (uploadedFile) {
        formData.append("Invoice", uploadedFile, uploadedFile.name);
      }

      const invoiceWithFile = selected.find((inv) => inv.remarkFile);
      if (invoiceWithFile) {
        const remark = invoiceWithFile.remarkFile;

        if (remark instanceof File) {
          formData.append("RemarkFile", remark, remark.name);
        } else if (remark?.url && typeof remark.url === "string") {
          const fileName = remark.name || "remark-file.pdf";
          try {
            const response = await fetch(remark.url);
            if (response.ok) {
              const blob = await response.blob();
              formData.append("RemarkFile", blob, fileName);
            } else {
              formData.append("RemarkFile", null);
            }
          } catch (err) {
            formData.append("RemarkFile", null);
          }
        } else {
          formData.append("RemarkFile", null);
        }
      } else {
        formData.append("RemarkFile", null);
      }

      setIsLoading(true);
      const response = await fetch(`${BASE_URL}/UpdateBatchData`, {
        method: "POST",
        body: formData,
      });
      console.log(formData, 'fomrmrrm')
      const result = await response.json();
      setIsLoading(false);

      if (!response.ok) {
        toast.error("Error saving batch. Check the payload or try again.");
        return;
      }
      const aanoString = selected.map((item) => item.aA_Number).join(",");

      const remarkFormData = new FormData();
      remarkFormData.append("AANo", aanoString);
      remarkFormData.append("Remark", "Batch Saved");
      remarkFormData.append("BatchNo", selectedBatchData.batchNo);
      remarkFormData.append("ByWhom", user?.role);
      try {
        const res = await fetch(`${BASE_URL}/UpdateRemarkAgainstBatch`, {
          method: "POST",
          body: remarkFormData,
        });
      } catch (remarkError) {
        console.error("Failed to update remarks:", remarkError);
      }

      localStorage.removeItem("invoices");
      await Swal.fire({
        title: "✅ Batch Saved Successfully",
        text: `Batch No: ${selectedBatchData?.batchNo || "-"} | Invoice No: ${invoiceNo}`,
        icon: "success",
        confirmButtonColor: "#7E00D1",
      });
      navigate("/invoice");
    } catch (error) {
      console.error("Save failed:", error);
      setIsLoading(false);
      toast.error("Save failed. Please check console for details.");
    }
  };

  const handleEdit = async (invoice) => {
    setEditingInvoice(invoice);
    setEditValues({
      serviceCharges: invoice.serviceCharges || "0.00",
      repairCharges: invoice.repairCharges || "0.00",
      remarks: invoice.remarks || "",
      file: invoice.remarkFile instanceof File ? invoice.remarkFile : null,
      fileName:
        invoice.remarkFile && typeof invoice.remarkFile === "object"
          ? invoice.remarkFile.name
          : invoice.remarkFile || "",
      billingType: invoice.billingType || "billing",
    });
    setModalClaimData(null);
    setActivePreviewTab("challan");
    setShowEditModal(true);

    try {
      const response = await fetch(`${BASE_URL}/GetAllGadgetClaimDetails?aaNumber=${invoice.aA_Number}`);
      const resData = await response.json();
      if (resData.status && resData.dataItems && resData.dataItems.length > 0) {
        setModalClaimData(resData.dataItems[0]);
      }
    } catch (err) {
      console.error("Error fetching claim details for modal preview:", err);
    }
  };

  const handleLOGSremarks = (aa_number) => {
    navigate(`/Remarks&Logs/${aa_number}`)
  }
  useEffect(() => {
    const storedInvoices = localStorage.getItem("invoices");
    if (storedInvoices) {
      setInvoices(JSON.parse(storedInvoices));
    }
  }, []);

  const handleSaveEdit = async () => {
    if (!editingInvoice) return;
    const parsedServiceCharges = parseFloat(editValues.serviceCharges);
    const parsedRepairCharges = parseFloat(editValues.repairCharges);
    const billingType = editValues.billingType;
    const remarks = editValues.remarks?.trim() || "";

    if (
      isNaN(parsedServiceCharges) ||
      parsedServiceCharges < 0 ||
      isNaN(parsedRepairCharges) ||
      parsedRepairCharges < 0
    ) {
      toast.error(
        "Service Charges and Repair Charges must be valid non-negative numbers."
      );
      return;
    }

    const isYellowRow = getRowClassName(editingInvoice) === "row-yellow";
    if (isYellowRow && !remarks) {
      setFieldErrors((prev) => ({
        ...prev,
        remarks: { ...prev.remarks, [editingInvoice.aA_Number]: true },
      }));
      toast.error("Remarks are required for mismatched data.");
      return;
    }

    const formattedServiceCharges = parsedServiceCharges.toFixed(2);
    const formattedRepairCharges = parsedRepairCharges.toFixed(2);
    const formattedTotal = (parsedServiceCharges + parsedRepairCharges).toFixed(2);

    // Update local state
    setInvoices((prevInvoices) => {
      const updated = prevInvoices.map((invoice) =>
        invoice.aA_Number === editingInvoice.aA_Number
          ? {
            ...invoice,
            serviceCharges: formattedServiceCharges,
            repairCharges: formattedRepairCharges,
            total: formattedTotal,
            remarks: remarks,
            billingType: billingType,
            isEdited: true,
            remarkFileUrl: editValues.file
              ? URL.createObjectURL(editValues.file) // Create object URL for local file
              : editValues.fileName
                ? editValues.fileName
                : null,
          }
          : invoice
      );


      localStorage.setItem("invoices", JSON.stringify(updated));
      return updated;
    });

    // Also update apiData state to reflect the changes
    setApiData((prev) => {
      return prev.map((item) =>
        item.aA_Number === editingInvoice.aA_Number
          ? {
            ...item,
            dataItems: [{
              ...item.dataItems[0],
              remarks: remarks,
              remarkFileUrl: editValues.file
                ? URL.createObjectURL(editValues.file)
                : editValues.fileName
                  ? editValues.fileName
                  : null
            }],
            remarks: remarks,
            remarkFileUrl: editValues.file
              ? URL.createObjectURL(editValues.file)
              : editValues.fileName
                ? editValues.fileName
                : null
          }
          : item
      );
    });

    setFieldErrors((prev) => ({
      ...prev,
      remarks: { ...prev.remarks, [editingInvoice.aA_Number]: false },
    }));

    // Call UpdateClaimRemarks API to save to backend
    try {
      const formData = new FormData();
      formData.append("AANo", editingInvoice.aA_Number);
      formData.append("Remark", `${editingInvoice.aA_Number}: ${remarks}`);
      formData.append("RemarkBy", user.role);

      if (editValues.file instanceof File) {
        formData.append("RemarkFile", editValues.file, editValues.file.name);
      } else {
        formData.append("RemarkFile", null);
      }

      // Generate selected PDF document as Blob
      let pdfDoc;
      let docName;
      if (editValues.billingType === "billing") {
        pdfDoc = downloadInvoicePDF(editingInvoice, [...getDisplayItems().repair, ...getDisplayItems().service], false);
        docName = `Invoice_${editingInvoice.aA_Number}.pdf`;
      } else {
        pdfDoc = new jsPDF();
        downloadChallanPDF(editingInvoice, getDisplayItems().repair, false, pdfDoc);
        pdfDoc.addPage();
        downloadInvoicePDF(editingInvoice, getDisplayItems().service, false, pdfDoc);
        docName = `Challan_Invoice_${editingInvoice.aA_Number}.pdf`;
      }
      const pdfBlob = pdfDoc.output('blob');

      formData.append("BillingType", editValues.billingType);
      formData.append("Document", pdfBlob, docName);

      const response = await fetch(`${BASE_URL}/UpdateClaimRemarks`, {
        method: "POST",
        body: formData,
      });
      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.message || "Failed to update claim remarks.");
      }

      // Refresh the API data for this specific invoice
      const refreshResponse = await fetch(
        `${BASE_URL}/GetGadgetCaseDetailsByAA?aaNumbers=${editingInvoice.aA_Number}`
      );

      if (refreshResponse.ok) {
        const refreshedData = await refreshResponse.json();

        if (refreshedData.dataItems && refreshedData.dataItems.length > 0) {
          const updatedApiItem = refreshedData.dataItems[0];

          // Update apiData state
          setApiData((prev) => {
            const updated = prev.map((item) =>
              item.aA_Number === editingInvoice.aA_Number
                ? {
                  ...item,
                  ...updatedApiItem,
                  remarkFileUrl: updatedApiItem.remarkFileUrl || null,
                }
                : item
            );
            return updated;
          });

          // Update invoices state with the refreshed API data
          setInvoices((prevInvoices) => {
            const updated = prevInvoices.map((invoice) =>
              invoice.aA_Number === editingInvoice.aA_Number
                ? {
                  ...invoice,
                  serviceCharges: formattedServiceCharges,
                  repairCharges: formattedRepairCharges,
                  total: formattedTotal,
                  remarks: updatedApiItem.remarks || remarks, // Use API remarks
                  billingType: editValues.billingType,
                  isEdited: true,
                  remarkFileUrl: updatedApiItem.remarkFileUrl || null, // Use API remarkFileUrl
                  documentFileUrl: updatedApiItem.documentFileUrl || null,
                }
                : invoice
            );
            localStorage.setItem("invoices", JSON.stringify(updated));
            return updated;
          });
        }
      }

      toast.success("Claim remarks updated successfully.");
    } catch (error) {
      console.error("Error updating claim remarks:", error);
      toast.error(`Failed to update claim remarks: ${error.message}`);
    }

    setShowEditModal(false);
    setEditingInvoice(null);
    setEditValues({
      serviceCharges: "",
      repairCharges: "",
      remarks: "",
      file: null,
      fileName: "",
    });
  };

  // const handleSaveRemark = async () => {
  //   try {
  //     const selected = invoices.filter((inv) => inv.isChecked);
  //     const aaNumbers = selected.map((inv) => inv.aA_Number).join(",");
  // 
  //     if (!aaNumbers) {
  //       console.warn("No AA Numbers found for remark update");
  //       return true;
  //     }
  // 
  //     const formData = new FormData();
  //     formData.append("aA_Number", aaNumbers);
  //     formData.append("remarks", batchRemark || "");
  //     formData.append("remarkAndLogBy", user.role);
  //     formData.append("batchNo", selectedBatchData?.batchNo);
  //     formData.append("logs", nextAction === "save" ? "Batch saved" : "Batch submitted for Approval");
  // 
  //     const res = await fetch(`${BASE_URL}/InsertLogsAndRemarksTracking`, {
  //       method: "POST",
  //       body: formData,
  //     });
  // 
  //     const data = await res.json();
  // 
  //     if (!res.ok || !data.status) {
  //       toast.error(data.message || "Failed to update remark.");
  //       return;
  //     }
  // 
  //     toast.success("Remark saved successfully.");
  // 
  //     setShowRemarkModal(false);
  // 
  //     if (nextAction === "save") {
  //       await handleSaveData();
  //     } else if (nextAction === "submit") {
  //       await handleSubmit();
  //     }
  // 
  //   } catch (err) {
  //     console.error("Remark update failed:", err);
  //     toast.error("Failed to update remark.");
  //   }
  // };

  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditValues((prev) => ({ ...prev, [name]: value }));
    if (name === "remarks" && editingInvoice) {
      setFieldErrors((prev) => ({
        ...prev,
        remarks: { ...prev.remarks, [editingInvoice.aA_Number]: !value.trim() },
      }));
    }
  };

  const handleCloseModal = () => {
    setShowEditModal(false);
    setEditingInvoice(null);
    setEditValues({
      serviceCharges: "",
      repairCharges: "",
      remarks: "",
      file: null,
      fileName: "",
    });
    if (editingInvoice) {
      setFieldErrors((prev) => ({
        ...prev,
        remarks: { ...prev.remarks, [editingInvoice.aA_Number]: false },
      }));
    }
  };

  const handleRemarkChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setEditValues((prev) => ({
        ...prev,
        file,
        fileName: file.name,
      }));
    }
  };

  const handleRemarkPreview = (remarkFile) => {
    if (remarkFile instanceof File) {
      // For locally uploaded files
      if (remarkFile.type === "application/pdf") {
        const fileURL = URL.createObjectURL(remarkFile);
        window.open(fileURL, "_blank");
        setTimeout(() => URL.revokeObjectURL(fileURL), 10000); // Clean up after 10 seconds
      } else {
        toast.error("Only PDF files can be previewed.");
      }
    } else if (remarkFile?.url && typeof remarkFile.url === "string") {
      // For API-provided files (URLs)
      window.open(remarkFile.url, "_blank");
    } else {
      toast.error("No valid file available for preview.");
    }
  };

  useEffect(() => {
    setCaseCount(selectedAAno?.length || 0);
    setInvoiceAmount(
      !isNaN(parseFloat(finalAmount)) ? parseFloat(finalAmount).toFixed(2) : ""
    );
  }, [selectedAAno, finalAmount]);

  const getFileNameFromUrl = (url) => {
    const params = new URLSearchParams(url.split("?")[1]);
    return decodeURIComponent(params.get("fileName"));
  };
  const renderDocumentPreview = () => {
    if (!editingInvoice) return null;

    const displayItems = getDisplayItems();
    const vendor = getVendorDetails(selectedBatchData?.vendorName || editingInvoice?.sellingPartner, modalClaimData?.ascState);
    const invoiceNo = selectedBatchData?.invoiceNo || `AA/CE/${editingInvoice?.id || 1}`;
    const invoiceDate = selectedBatchData?.invoiceDate
      ? new Date(selectedBatchData.invoiceDate).toLocaleDateString('en-GB').replace(/\//g, '-')
      : new Date().toLocaleDateString('en-GB').replace(/\//g, '-');

    // Choose document type based on Billing Type and active preview tab
    let previewTitle = "Tax Invoice";
    let itemsToRender = [];
    let showGstCol = true;
    let isChallanDoc = false;

    if (editValues.billingType === "billing") {
      previewTitle = "Tax Invoice";
      itemsToRender = [...displayItems.repair, ...displayItems.service];
      showGstCol = true;
      isChallanDoc = false;
    } else {
      if (activePreviewTab === "challan") {
        previewTitle = "Challan";
        itemsToRender = displayItems.repair;
        showGstCol = false;
        isChallanDoc = true;
      } else {
        previewTitle = "Tax Invoice";
        itemsToRender = displayItems.service;
        showGstCol = true;
        isChallanDoc = false;
      }
    }

    const previewTotalQty = itemsToRender.reduce((sum, item) => sum + item.quantity, 0);
    const previewSubTotal = itemsToRender.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    const previewTotalGst = isChallanDoc ? 0 : itemsToRender.reduce((sum, item) => sum + item.gstAmount, 0);
    const previewTotalWithGST = isChallanDoc ? previewSubTotal : itemsToRender.reduce((sum, item) => sum + item.amount, 0);
    const previewRoundedTotal = Math.round(previewTotalWithGST);
    const previewRoundOff = previewRoundedTotal - previewTotalWithGST;
    const previewAmountInWords = numberToWords(previewRoundedTotal);

    return (
      <div className="invoice-preview-container bg-white border rounded p-3 shadow-sm" style={{ fontSize: "11px", color: "#333", fontFamily: "Arial, sans-serif" }}>
        {/* Document Header */}
        <div className="d-flex justify-content-between align-items-start border-bottom pb-2 mb-2">
          <div>
            <h6 className="fw-bold m-0" style={{ fontSize: "14px", color: "#000" }}>{vendor.name}</h6>
            <div className="text-muted" style={{ fontSize: "10px", lineHeight: "1.3" }}>
              {vendor.address}<br />
              Phone no. : {vendor.phone}<br />
              GSTIN : {vendor.gstin}<br />
              State: {vendor.state}
            </div>
          </div>
        </div>

        {/* Title */}
        <div className="text-center my-2">
          <h6 className="fw-bold m-0" style={{ color: "#721c24", textTransform: "uppercase", letterSpacing: "1px", fontSize: "13px" }}>
            {previewTitle}
          </h6>
        </div>

        {/* To and Details */}
        <div className="row mb-3">
          <div className="col-7">
            <span className="fw-bold d-block text-dark" style={{ fontSize: "10px" }}>{isChallanDoc ? "To" : "Bill To"}</span>
            <span className="fw-bold text-dark d-block">
              Across Assist Pvt Ltd c/o {editingInvoice.customerName} ({editingInvoice.aA_Number})
            </span>
            <span className="text-muted d-block" style={{ lineHeight: "1.3" }}>
              {modalClaimData?.address || "Address Not Found"}<br />
              {modalClaimData?.pincode && `Pin Code - ${modalClaimData.pincode}`}<br />
              GST IN: 06AAHCB4822B1Z6
            </span>
          </div>
          <div className="col-5 text-end">
            <span className="fw-bold d-block text-dark" style={{ fontSize: "10px" }}>{isChallanDoc ? "Challan Details" : "Invoice Details"}</span>
            <span className="text-dark d-block">No. : <strong className="text-dark">{invoiceNo}</strong></span>
            <span className="text-dark d-block">Date : {invoiceDate}</span>
          </div>
        </div>

        {/* Table */}
        <div className="table-responsive mb-3">
          <table className="table table-bordered table-sm m-0 text-center" style={{ fontSize: "10px" }}>
            <thead>
              <tr style={{ backgroundColor: "#5C2518", color: "#ffffff" }}>
                <th style={{ width: "5%" }}>#</th>
                <th style={{ width: showGstCol ? "50%" : "65%", textAlign: "left" }}>Item name</th>
                <th style={{ width: "10%" }}>Qty</th>
                <th style={{ width: "10%" }}>Unit</th>
                <th style={{ width: "13%", textAlign: "right" }}>Price/ Unit</th>
                {showGstCol && <th style={{ width: "15%", textAlign: "right" }}>GST</th>}
                <th style={{ width: "12%", textAlign: "right" }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {itemsToRender.map((item, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td style={{ textAlign: "left" }}>{item.name}</td>
                  <td>{item.quantity}</td>
                  <td>{item.unit}</td>
                  <td style={{ textAlign: "right" }}>₹{item.price.toFixed(2)}</td>
                  {showGstCol && (
                    <td style={{ textAlign: "right" }}>
                      ₹{item.gstAmount.toFixed(2)} <span className="text-muted" style={{ fontSize: "9px" }}>({item.gstRate}%)</span>
                    </td>
                  )}
                  <td style={{ textAlign: "right" }}>
                    ₹{(isChallanDoc ? item.price : item.amount).toFixed(2)}
                  </td>
                </tr>
              ))}
              {/* Total Row */}
              <tr className="fw-bold bg-light">
                <td colSpan="2" style={{ textAlign: "left" }}>Total</td>
                <td>{previewTotalQty}</td>
                <td></td>
                <td></td>
                {showGstCol && <td></td>}
                <td style={{ textAlign: "right" }}>₹{previewTotalWithGST.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Footer Summary Blocks */}
        <div className="row pt-2 border-top">
          {/* Left Block */}
          <div className="col-7">
            <div className="mb-2">
              <span className="fw-bold text-dark d-block">Description</span>
              <span className="text-muted d-block">
                Repair support for {editingInvoice.brand} {editingInvoice.makeModel}<br />
                IMEI: {editingInvoice.imeiNumber}
              </span>
            </div>
            <div className="mb-2">
              <span className="fw-bold text-dark d-block">Amount In Words</span>
              <span className="text-muted d-block fw-semibold text-wrap" style={{ fontSize: "9.5px" }}>
                {previewAmountInWords}
              </span>
            </div>
            <div>
              <span className="fw-bold text-dark d-block">Terms and Conditions</span>
              <span className="text-muted d-block">1. E.&O.E.</span>
            </div>
          </div>

          {/* Right Block */}
          <div className="col-5 text-end">
            <div className="border rounded mb-3 bg-light text-start">
              <div className="d-flex justify-content-between p-1 border-bottom">
                <span>Sub Total</span>
                <span>₹{previewSubTotal.toFixed(2)}</span>
              </div>
              {!isChallanDoc && (
                <div className="d-flex justify-content-between p-1 border-bottom">
                  <span>IGST@18%</span>
                  <span>₹{previewTotalGst.toFixed(2)}</span>
                </div>
              )}
              <div className="d-flex justify-content-between p-1 border-bottom">
                <span>Round off</span>
                <span>{previewRoundOff >= 0 ? "+" : ""}{previewRoundOff.toFixed(2)}</span>
              </div>
              <div className="d-flex justify-content-between p-1 fw-bold text-white" style={{ backgroundColor: "#5C2518" }}>
                <span>Total</span>
                <span>₹{previewRoundedTotal.toFixed(2)}</span>
              </div>
              {!isChallanDoc && (
                <>
                  <div className="d-flex justify-content-between p-1 border-bottom">
                    <span>Received</span>
                    <span>₹0.00</span>
                  </div>
                  <div className="d-flex justify-content-between p-1 fw-bold">
                    <span>Balance</span>
                    <span>₹{previewRoundedTotal.toFixed(2)}</span>
                  </div>
                </>
              )}
            </div>

            {/* Signature Area */}
            <div className="text-center pt-2 relative" style={{ minHeight: "100px" }}>
              <span className="text-muted d-block mb-1" style={{ fontSize: "9px" }}>For : {vendor.name}</span>

              <div
                className="d-inline-flex flex-column align-items-center justify-content-center rounded-circle border border-primary p-1"
                style={{
                  width: "56px",
                  height: "56px",
                  borderColor: "#003399",
                  borderStyle: "solid",
                  borderWidth: "1.5px",
                  transform: "rotate(-12deg)",
                  color: "#003399",
                  margin: "5px 0",
                  opacity: 0.85,
                  userSelect: "none"
                }}
              >
                <span style={{ fontSize: "5px", fontWeight: "bold" }}>CHITRANSH</span>
                <span style={{ fontSize: "9px", fontFamily: "cursive", fontWeight: "bold", fontStyle: "italic", margin: "-2px 0" }}>Honey</span>
                <span style={{ fontSize: "5px", fontWeight: "bold" }}>ENTERPRISES</span>
              </div>

              <span className="fw-bold text-dark d-block mt-2" style={{ fontSize: "9.5px" }}>Authorized Signatory</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const allRowsChecked =
    invoices.length > 0 && invoices.every((invoice) => invoice.isChecked);

  return (
    <div
      className="container py-4"
      style={{ backgroundColor: "#f8f9fa" }}
    >
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="card shadow-sm p-4">
        <div
          className="d-flex justify-content-between align-items-center mb-4"
          style={{
            backgroundColor: "#e6f0ff",
            padding: "15px",
            borderRadius: "8px",
          }}
        >
          <h2 className="mb-0">Upload Invoice</h2>
          <button
            className="btn btn-primary d-flex align-items-center"
            style={{
              backgroundColor: "#8000d7",
              border: "none",
              padding: "10px 16px",
              borderRadius: "8px",
              fontWeight: "500",
              fontSize: "14px",
            }}
            // onClick={() => navigate(-1)}
            onClick={handleBackClick}

          >
            Back
          </button>
        </div>

        <div className="netwrok_table_main_content">
          <div className="d-flex justify-content-between align-items-center gap-2 mb-3">
            <div className="d-flex flex-wrap gap-2 align-items-center">
              {selectedBatchData?.batchNo && (
                <div className="fw-semibold">
                  <span>Batch No: </span>
                  <span className="text-primary">
                    {selectedBatchData.batchNo}
                  </span>
                </div>
              )}
              {selectedBatchData?.vendorName && (
                <div className="fw-semibold">
                  <span>Vendor: </span>
                  <span className="text-success">
                    {selectedBatchData.vendorName}
                  </span>
                </div>
              )}
            </div>
            <div className="d-flex gap-2">
              <button
                className="btn btn-primary d-flex align-items-center"
                style={{
                  backgroundColor: "#8000d7",
                  border: "none",
                  padding: "10px 16px",
                  borderRadius: "8px",
                  fontWeight: "500",
                  fontSize: "14px",
                }}
                onClick={handleAddAAnumber}
              >
                <FaPlus /> <span className="ms-2">Add AA Number</span>
              </button>
              <button
                className="btn btn-primary d-flex align-items-center"
                style={{
                  backgroundColor: "#8000d7",
                  border: "none",
                  padding: "10px 16px",
                  borderRadius: "8px",
                  fontWeight: "500",
                  fontSize: "14px",
                }}
                onClick={handleClick}
              >
                <FaUpload /> <span className="ms-2">Upload Invoice</span>
              </button>

              <input
                type="file"
                ref={fileInputRef}
                onChange={(e) => {
                  handleFileChange(e);
                  setFieldErrors((prev) => ({ ...prev, uploadedFile: false }));
                }}
                style={{ display: "none" }}
                accept=".pdf, .jpg, .jpeg, .png"
              />
            </div>
          </div>
          {/* ---- Filter & Search Section ---- */}
          <div className="d-flex flex-wrap justify-content-between align-items-end gap-3 mb-3">
            <div className="d-flex flex-wrap align-items-end gap-3">
              {showFilter && (
                <>
                  <div>
                    <label className="form-label">Filter By</label>
                    <select
                      className="form-select"
                      value={filterType}
                      onChange={(e) => setFilterType(e.target.value)}
                    >
                      <option value="closure">Closure Date</option>
                    </select>
                  </div>

                  <div>
                    <label className="form-label">From Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      max={toDate || new Date().toISOString().split('T')[0]}
                    />
                  </div>

                  <div>
                    <label className="form-label">To Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      max={new Date().toISOString().split('T')[0]} // Don't allow future dates
                      min={fromDate} // Don't allow dates before fromDate
                    />
                  </div>

                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-outline-secondary"
                      onClick={() => {
                        setFromDate("");
                        setToDate("");
                      }}
                    >
                      Reset
                    </button>
                  </div>
                  <div>
                    <label className="form-label">Search by AA Number</label>
                    <input
                      type="text"
                      className="form-control"
                      value={aaNumber}
                      placeholder="Enter AA Number"
                      onChange={(e) => setAaNumber(e.target.value)}
                    />
                  </div>
                </>
              )}
            </div>
          </div>

          {selectedBatchData?.invoice ? (
            <div className="text-end upload_file_ext_name mb-3">
              <span className="fw-bold text-success" style={{ cursor: "pointer" }} onClick={() => window.open(selectedBatchData.invoice, "_blank")}>
                {getFileNameFromUrl(selectedBatchData?.invoice)}
              </span>
              {selectedBatchData.invoice.endsWith(".pdf") ? (
                <img
                  src={pdfimage}
                  alt="PDF Icon"
                  style={{ width: "24px", height: "24px", marginLeft: "10px" }}
                />
              ) : (
                ""
              )}
            </div>
          ) : (
            fileType &&
            uploadedFile && (
              <div className="text-end upload_file_ext_name mb-3">
                <span className="fw-bold text-success" style={{ cursor: "pointer" }} onClick={() => window.open(URL.createObjectURL(uploadedFile), "_blank")}>
                  {uploadedFile.name}
                </span>

                {fileType === "pdf" ? (
                  <img
                    src={pdfimage}
                    alt="PDF Icon"
                    style={{ width: "24px", height: "24px", marginLeft: "10px" }}
                  />
                ) : fileType === "image" ? (
                  <img
                    src={URL.createObjectURL(uploadedFile)}
                    alt="Image Preview"
                    style={{ width: "50px", height: "50px", marginLeft: "10px", objectFit: "cover", borderRadius: "4px" }}
                  />
                ) : null}
              </div>
            )
          )}

          {!uploadedFile && !selectedBatchData?.invoice && fieldErrors.uploadedFile && (
            <div className="text-danger mb-3" style={{ fontSize: "14px" }}>
              Please upload an invoice file.
            </div>
          )}

          <div
            className="table-container mt-3"
            style={{ overflowX: "auto", overflowY: "auto" }}
          >
            <Table className="table-auto bg-white text-center border-dark network_table">
              <thead
                style={{
                  backgroundColor: "#EEF4FF",
                  position: "sticky",
                  top: "0",
                  zIndex: "1",
                }}
              >
                <tr className="text-dark fw-semibold table_th_border">
                  <th className="border-start">Select</th>
                  <th className="border-start">View</th>
                  <th className="border-start">Validate</th>
                  <th className="border-start">Remarks</th>
                  <th className="border-end border-start" style={{ whiteSpace: "nowrap" }}>
                    Action
                  </th>
                  <th style={{ whiteSpace: "nowrap" }}>AA No</th>
                  <th style={{ whiteSpace: "nowrap" }}>IMEI No</th>

                  <th style={{ whiteSpace: "nowrap" }}>Customer Name</th>
                  {/* <th style={{ whiteSpace: "nowrap" }}>Service Type</th>
                  <th style={{ whiteSpace: "nowrap" }}>Selling Partner</th> */}
                  <th style={{ whiteSpace: "nowrap" }}>Brand</th>
                  <th style={{ whiteSpace: "nowrap" }}>Make Model</th>
                  <th style={{ whiteSpace: "nowrap" }}>Repair Charges</th>
                  <th style={{ whiteSpace: "nowrap" }}>Logistics and Repair Support Fees(Pre GST)</th>
                  <th style={{ whiteSpace: "nowrap" }}>Total</th>
                  <th style={{ whiteSpace: "nowrap" }}>Creation Date</th>
                  <th style={{ whiteSpace: "nowrap" }}>Closure Date</th>
                  <th style={{ whiteSpace: "nowrap" }}>Invoice Status</th>
                  <th style={{ whiteSpace: "nowrap" }}>Mismatched Data</th>
                  {/* <th className="border-end" style={{ whiteSpace: "nowrap" }}>
                    Remarks
                  </th>
                  <th className="border-end" style={{ whiteSpace: "nowrap" }}>
                    Remark File
                  </th> */}
                  <th style={{ whiteSpace: "nowrap" }}>Document</th>
                  <th className="border-end" style={{ whiteSpace: "nowrap" }}>
                    Billing Type
                  </th>

                </tr>
              </thead>
              <tbody>
                {isLoading && (
                  <tr>
                    <td colSpan="20" className="text-center py-3">
                      Validating data...
                    </td>
                  </tr>
                )}
                {!isLoading &&
                  currentInvoices.map((invoice, index) => (
                    <tr
                      key={invoice.id || `${invoice.aA_Number}-${index}`}
                      className={`text-center border-bottom network_td_item ${getRowClassName(
                        invoice
                      )}`}
                      aria-label="Invoice row"
                    >
                      <td className="border-start align-middle">
                        <Form.Check
                          type="checkbox"
                          checked={invoice.isChecked}
                          onChange={() =>
                            handleCheckboxChange(invoice.aA_Number)
                          }
                        />
                      </td>
                      <td className="border-start align-middle">
                        <FaEye
                          size={25}
                          className="text-purple-600 review_fa_eye"
                          style={{ cursor: "pointer" }}
                          // onClick={() =>
                          //   navigate("/invoice-template", {
                          //     state: { aaNumber: invoice.aA_Number },
                          //   })
                          // }
                          onClick={() => handleViewClick(invoice.aA_Number)}

                        />
                      </td>
                      <td className="border-start align-middle">
                        <FaEdit
                          size={20}
                          className="text-purple-600 review_fa_eye"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleEdit(invoice)}
                        />
                      </td>
                      <td className="border-start align-middle">
                        <FaReceipt
                          size={20}
                          className="text-purple-600 review_fa_eye"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleLOGSremarks(invoice.aA_Number)}
                        />
                      </td>
                      <td
                        className="align-middle border-end border-start pointer-cursor"
                        style={{ cursor: "pointer" }}
                      >
                        <FaTrash
                          onClick={() => handleDelete(invoice.aA_Number)}
                          size={25}
                          style={{ color: "red" }}
                        />
                      </td>
                      <td className="align-middle">
                        {invoice.aA_Number || "-"}
                      </td>
                      <td className="align-middle">
                        {invoice.imeiNumber || "-"}
                      </td>

                      <td className="align-middle">
                        {invoice.customerName || "-"}
                      </td>
                      {/* <td className="align-middle">
                        {invoice.serviceType || "-"}
                      </td>
                      <td className="align-middle">
                        {invoice.sellingPartner || "-"}
                      </td> */}
                      <td className="align-middle">{invoice.brand || "-"}</td>
                      <td className="align-middle">
                        {invoice.makeModel || "-"}
                      </td>
                      <td className="align-middle">
                        {invoice.repairCharges || "0.00"}
                      </td>
                      <td className="align-middle">
                        {invoice.serviceCharges || "0.00"}
                      </td>
                      <td className="align-middle">
                        {invoice.total || "0.00"}
                      </td>
                      <td className="align-middle">
                        {invoice.creationDate
                          ? formatDate(invoice.creationDate)
                          : "--"}
                      </td>
                      <td className="align-middle">
                        {invoice.closureDate
                          ? formatDate(invoice.closureDate)
                          : "--"}
                      </td>
                      <td className="align-middle">
                        <span
                          className="vendore_invoice_status px-3 py-1 rounded-pill"
                          style={{
                            display: "inline-block",
                            border: `1px solid ${invoice.invoiceStatus === "Re-Assigned" ? "#dc3545" : "#0d6efd"
                              }`,
                            color:
                              invoice.invoiceStatus === "Re-Assigned" ? "#dc3545" : "#0d6efd",
                            backgroundColor:
                              invoice.invoiceStatus === "Re-Assigned" ? "#f8d7da" : "#dff6ff",
                            fontWeight: 600,
                            fontSize: "13px",
                          }}
                        >
                          {invoice.invoiceStatus}
                        </span>
                      </td>
                      <td className="align-middle">
                        {getDifferencesData(invoice).length > 0
                          ? "Mismatch"
                          : "Valid"}
                        <div
                          className="align-middle position-relative"
                          onMouseEnter={() => setHoveredRow(index)}
                          onMouseLeave={() => setHoveredRow(null)}
                          style={{ cursor: "pointer", position: "relative" }}
                        >
                          {getDifferencesData(invoice).length > 0
                            ? "View Details"
                            : ""}
                          {hoveredRow === index &&
                            getDifferencesData(invoice).length > 0 && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "100%",
                                  left: "-18%",
                                  transform: "translateX(-50%)",
                                  zIndex: "1000",
                                  backgroundColor: "#ffffff",
                                  border: "1px solid #ddd",
                                  padding: "10px",
                                  boxShadow: "0px 4px 8px rgba(0,0,0,0.3)",
                                  minWidth: "300px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <table className="table table-sm table-bordered table-hover mb-0">
                                  <thead>
                                    <tr>
                                      <th className="text-left">Field</th>
                                      <th className="text-left">Excel Data</th>
                                      <th className="text-left">System Data</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {getDifferencesData(invoice).map(
                                      (diff, i) => (
                                        <tr key={i}>
                                          <td className="text-left">
                                            {diff.field}
                                          </td>
                                          <td className="text-left">
                                            {diff.table}
                                          </td>
                                          <td className="text-left">
                                            {diff.api}
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            )}
                        </div>
                      </td>
                      {/* <td className="align-middle border-end">
                        <span>
                          {invoice.remarks || "-"}
                          {getRowClassName(invoice) === "row-yellow" &&
                            !invoice.remarks && (
                              <span className="text-danger ms-1">*</span>
                            )}
                        </span>
                      </td>
                      <td className="align-middle border-end">
                        {invoice.remarkFileUrl ? (
                          <a
                            href={invoice.remarkFileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "#8000d7",
                              textDecoration: "underline",
                            }}
                          >
                            View File
                          </a>
                        ) : (
                          "-"
                        )}
                      </td> */}
                      <td className="align-middle">
                        {invoice.documentFileUrl ? (
                          <a
                            href={invoice.documentFileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "#8000d7",
                              textDecoration: "underline",
                              whiteSpace: "nowrap",
                            }}
                          >
                            View PDF
                          </a>
                        ) : (
                          "-"
                        )}
                      </td>

                      <td className="align-middle border-end">
                        {invoice.billingType || "-"}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>
          <Modal show={openRemarkModal} onHide={() => setOpenRemarkModal(false)} centered size="md">
            <Modal.Header closeButton style={{ backgroundColor: "#EBF3FF" }}>
              <Modal.Title>Selected AAnumber will be deleted </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Remarks</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    placeholder="Enter remark"
                  />
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="danger" onClick={() => setOpenRemarkModal(false)}>
                Cancel
              </Button>
              <Button
                variant="primary"
                style={{ backgroundColor: "#8000d7", border: "none" }}
                onClick={handleSubmitRemark}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Modal>
          <div className="d-flex justify-content-between align-items-center pagination-container mt-3">
            <button
              className="btn btn-outline-primary"
              onClick={handlePrevious}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span className="page-info">
              Page {currentPage} of {totalPages}
            </span>
            <button
              className="btn btn-outline-primary"
              onClick={handleNext}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>

          <div className="row justify-content-between align-items-start mt-2">
            {/* Left Column */}
            <div className="col-12">
              {/* GST Toggle */}
              <div className="border rounded p-2 mt-4">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="fw-bold ms-2">
                    <span>GST</span>
                  </div>
                  <div className="d-flex gap-3">
                    <label className="registration_kc_radio">
                      <input
                        type="radio"
                        name="gstApplied"
                        checked={isGSTApplied === true}
                        onChange={() => setIsGSTApplied(true)}
                      />
                      <span className="registration_applied_yes">Yes</span>
                    </label>
                    <span className="mx-1">/</span>
                    <label className="registration_kc_radio">
                      <input
                        type="radio"
                        name="gstApplied"
                        checked={isGSTApplied === false}
                        onChange={() => setIsGSTApplied(false)}
                      />
                      <span className="registration_applied_yes">No</span>
                    </label>
                  </div>
                </div>
              </div>

              {/* Selected Services */}
              <div
                style={{
                  backgroundColor: "#eef4ff",
                  marginTop: "8px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                  padding: "16px",
                  whiteSpace: "nowrap",
                }}
              >
                <span style={{ fontWeight: 600, color: "gray" }}>
                  Total no of selected Service:
                </span>
                <span style={{ fontWeight: "bold", color: "black" }}>
                  {selectedAAno.length}
                </span>
              </div>

              {/* Amount Summary */}
              <div
                className="batch_popup_gross_ammount mt-2 w-100"
                style={{ backgroundColor: "#eef4ff", marginTop: "1rem" }}
              >
                <div className="d-flex justify-content-between batch_popup_amount">
                  <div className="fw-bold batch_gross">Total Repair Charges</div>
                  <div className="text-end batch_amount_to_fix">
                    ₹ {totalRepairCharges.toFixed(2)}
                  </div>
                </div>

                <div className="d-flex justify-content-between batch_popup_amount">
                  <div className="fw-bold batch_gross">Total Logistics and Repair Support Fees</div>
                  <div className="d-flex align-items-center">
                    <div className="batch_amount_to_fix">
                      ₹ {totalservicechargewithGST} ({isGSTApplied ? "incl GST 18%" : "excl GST"})
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-between batch_popup_amount">
                  <div className="fw-bold batch_gross">Final Amount</div>
                  <div className="batch_amount_to_fix" style={{ fontSize: "14px" }}>
                    <b>₹ {finalAmount}</b>
                  </div>
                </div>

                <div className="mt-2 d-flex justify-content-end">
                  <span className="fw-semibold text-secondary" style={{ fontSize: "13px" }}>
                    {isGSTApplied
                      ? `GST Amount Added: ₹${gstAmount}`
                      : `No GST Applied (₹${gstAmount})`}
                  </span>
                </div>
              </div>
            </div>
          </div>


          <div className="d-flex mt-4 justify-content-center gap-3">
            <button
              onClick={downloadCSV}
              className="btn btn-primary d-flex align-items-center"
              style={{
                backgroundColor: "rgb(248, 238, 255)",
                border: "1px solid #8000d7",
                padding: "10px 50px",
                borderRadius: "8px",
                fontWeight: "500",
                fontSize: "14px",
                color: "#8000d7",
              }}
            >
              <FaDownload />
              <span className="ms-2">Download</span>
            </button>
            <button
              onClick={handleSaveData}
              className="btn btn-primary d-flex align-items-center"
              style={{
                backgroundColor: "#8000d7",
                border: "none",
                padding: "10px 50px",
                borderRadius: "8px",
                fontWeight: "500",
                fontSize: "16px",
                color: "white",
              }}
              disabled={isLoading || (!allRowsChecked && !showaaNumber)}
            >
              {isLoading ? "Saving..." : "Save"}
            </button>
            <button
              onClick={handleSubmit}
              className="btn btn-primary d-flex align-items-center"
              style={{
                backgroundColor: "#8000d7",
                border: "none",
                padding: "10px 50px",
                borderRadius: "8px",
                fontWeight: "500",
                fontSize: "16px",
                color: "white",
              }}
              disabled={isLoading}
            >
              {isLoading ? "Processing..." : "Submit For Approval"}
            </button>

          </div>
        </div>
      </div>

      {/* Edit Modal */}
      <Modal show={showEditModal} onHide={handleCloseModal} centered size="xl">
        <Modal.Header closeButton style={{ backgroundColor: "#EBF3FF" }}>
          <Modal.Title>
            Edit Invoices (AA No: {editingInvoice?.aA_Number})
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            {/* Left Side: Form Controls */}
            <div className="col-md-5 border-end">
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Billing Type</Form.Label>
                  <Form.Select
                    name="billingType"
                    value={editValues.billingType}
                    onChange={handleEditInputChange}
                    size="lg"
                  >
                    <option value="billing">Billing</option>
                    <option value="reimbursement">Reimbursement</option>
                  </Form.Select>
                </Form.Group>
                {editValues.billingType === "reimbursement" ? (
                  <Alert variant="info" className="mb-3" style={{ fontSize: "12px" }}>
                    <strong>Reimbursement Mode:</strong>
                    <ul className="mb-0 mt-2">
                      <li>Repair Charges → Reimbursement Challan</li>
                      <li>Service Charges → Logistics Invoice</li>
                    </ul>
                  </Alert>
                ) : (
                  <Alert variant="info" className="mb-3" style={{ fontSize: "12px" }}>
                    <strong>Billing Mode:</strong>
                    <ul className="mb-0 mt-2">
                      <li>
                        Single Invoice will be generated for total amount (
                        Repair Charges + Logistics Charges)
                      </li>
                    </ul>
                  </Alert>
                )}
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Repair Charges</Form.Label>
                  <Form.Control
                    type="number"
                    name="repairCharges"
                    value={editValues.repairCharges}
                    onChange={handleEditInputChange}
                    min="0"
                    step="0.01"
                    placeholder="Enter Repair Charges"
                    size="lg"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Logistics and Repair Support Fees</Form.Label>
                  <Form.Control
                    type="number"
                    name="serviceCharges"
                    value={editValues.serviceCharges}
                    onChange={handleEditInputChange}
                    min="0"
                    step="0.01"
                    size="lg"
                    placeholder="Enter Service Charges"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Remarks</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="remarks"
                    value={editValues.remarks}
                    onChange={handleEditInputChange}
                    placeholder="Enter Remarks"
                    className={
                      fieldErrors.remarks[editingInvoice?.aA_Number]
                        ? "is-invalid"
                        : ""
                    }
                  />
                  {fieldErrors.remarks[editingInvoice?.aA_Number] && (
                    <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                      Remarks are required for mismatched data.
                    </div>
                  )}
                </Form.Group>
                <Form.Group controlId="formFile" className="mb-3">
                  <Form.Label
                    className="btn btn-secondary mb-0"
                    style={{
                      backgroundColor: "#8000d7",
                      border: "none",
                    }}
                    onClick={() => modalFileInputRef.current.click()}
                  >
                    Upload Remark File
                  </Form.Label>
                  <Form.Control
                    type="file"
                    id="fileUpload"
                    name="uploadedFile"
                    onChange={handleRemarkChange}
                    style={{ display: "none" }}
                    ref={modalFileInputRef}
                  />
                  {editValues.fileName && (
                    <div className="mt-2 d-flex align-items-center">
                      <span className="text-muted me-2" style={{ fontSize: "12px" }}>
                        Selected File: {editValues.fileName}
                      </span>
                      {editValues.file && editValues.file.type === "application/pdf" && (
                        <Button
                          variant="link"
                          className="p-0"
                          onClick={() => handleRemarkPreview(editValues.file)}
                          style={{ fontSize: "12px", color: "#8000d7" }}
                        >
                          <FaEye className="me-1" /> Preview PDF
                        </Button>
                      )}
                    </div>
                  )}
                  {editingInvoice?.remarkFile && !editValues.file && (
                    <div className="mt-2 d-flex align-items-center">
                      <span className="text-muted me-2" style={{ fontSize: "12px" }}>
                        Existing File: {editingInvoice.remarkFile.name}
                      </span>
                      <Button
                        variant="link"
                        className="p-0"
                        onClick={() => handleRemarkPreview(editingInvoice.remarkFile)}
                        style={{ fontSize: "12px", color: "#8000d7" }}
                      >
                        <FaEye className="me-1" /> Preview PDF
                      </Button>
                    </div>
                  )}
                </Form.Group>
              </Form>
            </div>

            {/* Right Side: Document Preview & Downloads */}
            <div className="col-md-7 d-flex flex-column" style={{ minHeight: "550px" }}>
              <div className="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
                <span className="fw-bold text-dark" style={{ fontSize: "16px" }}>Document Live Preview</span>
                {editValues.billingType === "reimbursement" && (
                  <div className="d-flex gap-2">
                    <Button
                      variant={activePreviewTab === "challan" ? "primary" : "outline-primary"}
                      onClick={() => setActivePreviewTab("challan")}
                      size="sm"
                      style={{ fontSize: "11px", padding: "4px 8px" }}
                    >
                      Challan (Repair)
                    </Button>
                    <Button
                      variant={activePreviewTab === "invoice" ? "primary" : "outline-primary"}
                      onClick={() => setActivePreviewTab("invoice")}
                      size="sm"
                      style={{ fontSize: "11px", padding: "4px 8px" }}
                    >
                      Logistics Invoice (Logistics)
                    </Button>
                  </div>
                )}
              </div>

              {/* Scrollable Preview Frame */}
              <div className="flex-grow-1 overflow-auto border rounded bg-light p-2 mb-3" style={{ maxHeight: "500px" }}>
                {renderDocumentPreview()}
              </div>

              {/* Download buttons bar */}
              <div className="d-flex gap-2 justify-content-end align-items-center border-top pt-2">
                <span className="text-muted me-auto" style={{ fontSize: "11px" }}>
                  * Preview shows dynamic data based on inputs & API response.
                </span>
                {editValues.billingType === "billing" ? (
                  <Button
                    variant="success"
                    onClick={() => downloadInvoicePDF(editingInvoice, [...getDisplayItems().repair, ...getDisplayItems().service])}
                    size="sm"
                    className="d-flex align-items-center gap-1"
                    style={{ backgroundColor: "#28a745", borderColor: "#28a745" }}
                  >
                    <FaDownload /> Download Tax Invoice
                  </Button>
                ) : (
                  <>
                    <Button
                      variant="success"
                      onClick={() => downloadChallanPDF(editingInvoice, getDisplayItems().repair)}
                      size="sm"
                      className="d-flex align-items-center gap-1"
                      style={{ backgroundColor: "#28a745", borderColor: "#28a745" }}
                    >
                      <FaDownload /> Download Challan
                    </Button>
                    <Button
                      variant="success"
                      onClick={() => downloadInvoicePDF(editingInvoice, getDisplayItems().service)}
                      size="sm"
                      className="d-flex align-items-center gap-1"
                      style={{ backgroundColor: "#28a745", borderColor: "#28a745" }}
                    >
                      <FaDownload /> Download Logistics Invoice
                    </Button>
                  </>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSaveEdit}
            style={{
              backgroundColor: "#8000d7",
              border: "none",
            }}
            disabled={isLoading}
          >
            {isLoading ? "Saving..." : "Save Changes"}
          </Button>
        </Modal.Footer>
      </Modal>
      {/* {showRemarkModal && (
        <div className="modal show fade d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content custom-modal">
              <div className="modal-header">
                <h5 className="modal-title">
                  Selected cases will be <strong>{modalActionType}</strong>
                </h5>
                <button type="button" className="btn-close" onClick={() => setShowRemarkModal(false)}></button>
              </div>
              <div className="modal-body">
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Enter your remarks..."
                  value={batchRemark}
                  onChange={(e) => setBatchRemark(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowRemarkModal(false)}>Cancel</button>
                <button className="btn btn-primary" onClick={handleSaveRemark}>Save Remark</button>
              </div>
            </div>
          </div>
        </div>
      )} */}

      <style jsx>{`
        .table-container {
          overflow-x: auto;
          overflow-y: auto;
          max-height: 400px;
          width: 100%;
        }
        .network_table {
          min-width: 1200px;
        }
        .network_table th,
        .network_table td {
          padding: 2px;
          vertical-align: top;
        }
        .vendore_invoice_status {
          display: inline-block;
          white-space: nowrap;
        }
        .page-info {
          margin-top: 1rem;
          font-weight: 500;
        }
        .row-red {
          background-color: #ffe6e6;
          color: #d32f2f;
        }
        .row-yellow {
          background-color: #fff9c4;
        }
        .row-green {
          background-color: #e8f5e9;
        }
      `}</style>
    </div>
  );
};

export default ReviewBatchPage;